// Auto-generated mapping from web-ifc's uppercase type names
// (returned by GetNameFromTypeCode) to canonical mixed-case names
// (matching schema docs, ifcopenshell, and our backend's CLASS_TO_PSET).
// Source: node_modules/web-ifc/ifc-schema.d.ts (`class Ifc...` declarations).
// Regenerate by running scripts/regen-ifc-canonical.mjs after upgrading web-ifc.

const IFC_CANONICAL_NAMES: Record<string, string> = {
  IFCABSORBEDDOSEMEASURE: 'IfcAbsorbedDoseMeasure',
  IFCACCELERATIONMEASURE: 'IfcAccelerationMeasure',
  IFCACTIONREQUEST: 'IfcActionRequest',
  IFCACTIONREQUESTTYPEENUM: 'IfcActionRequestTypeEnum',
  IFCACTIONSOURCETYPEENUM: 'IfcActionSourceTypeEnum',
  IFCACTIONTYPEENUM: 'IfcActionTypeEnum',
  IFCACTOR: 'IfcActor',
  IFCACTORROLE: 'IfcActorRole',
  IFCACTUATOR: 'IfcActuator',
  IFCACTUATORTYPE: 'IfcActuatorType',
  IFCACTUATORTYPEENUM: 'IfcActuatorTypeEnum',
  IFCADDRESS: 'IfcAddress',
  IFCADDRESSTYPEENUM: 'IfcAddressTypeEnum',
  IFCADVANCEDBREP: 'IfcAdvancedBrep',
  IFCADVANCEDBREPWITHVOIDS: 'IfcAdvancedBrepWithVoids',
  IFCADVANCEDFACE: 'IfcAdvancedFace',
  IFCAHEADORBEHIND: 'IfcAheadOrBehind',
  IFCAIRTERMINAL: 'IfcAirTerminal',
  IFCAIRTERMINALBOX: 'IfcAirTerminalBox',
  IFCAIRTERMINALBOXTYPE: 'IfcAirTerminalBoxType',
  IFCAIRTERMINALBOXTYPEENUM: 'IfcAirTerminalBoxTypeEnum',
  IFCAIRTERMINALTYPE: 'IfcAirTerminalType',
  IFCAIRTERMINALTYPEENUM: 'IfcAirTerminalTypeEnum',
  IFCAIRTOAIRHEATRECOVERY: 'IfcAirToAirHeatRecovery',
  IFCAIRTOAIRHEATRECOVERYTYPE: 'IfcAirToAirHeatRecoveryType',
  IFCAIRTOAIRHEATRECOVERYTYPEENUM: 'IfcAirToAirHeatRecoveryTypeEnum',
  IFCALARM: 'IfcAlarm',
  IFCALARMTYPE: 'IfcAlarmType',
  IFCALARMTYPEENUM: 'IfcAlarmTypeEnum',
  IFCALIGNMENT: 'IfcAlignment',
  IFCALIGNMENTCANT: 'IfcAlignmentCant',
  IFCALIGNMENTCANTSEGMENT: 'IfcAlignmentCantSegment',
  IFCALIGNMENTCANTSEGMENTTYPEENUM: 'IfcAlignmentCantSegmentTypeEnum',
  IFCALIGNMENTHORIZONTAL: 'IfcAlignmentHorizontal',
  IFCALIGNMENTHORIZONTALSEGMENT: 'IfcAlignmentHorizontalSegment',
  IFCALIGNMENTHORIZONTALSEGMENTTYPEENUM: 'IfcAlignmentHorizontalSegmentTypeEnum',
  IFCALIGNMENTPARAMETERSEGMENT: 'IfcAlignmentParameterSegment',
  IFCALIGNMENTSEGMENT: 'IfcAlignmentSegment',
  IFCALIGNMENTTYPEENUM: 'IfcAlignmentTypeEnum',
  IFCALIGNMENTVERTICAL: 'IfcAlignmentVertical',
  IFCALIGNMENTVERTICALSEGMENT: 'IfcAlignmentVerticalSegment',
  IFCALIGNMENTVERTICALSEGMENTTYPEENUM: 'IfcAlignmentVerticalSegmentTypeEnum',
  IFCAMOUNTOFSUBSTANCEMEASURE: 'IfcAmountOfSubstanceMeasure',
  IFCANALYSISMODELTYPEENUM: 'IfcAnalysisModelTypeEnum',
  IFCANALYSISTHEORYTYPEENUM: 'IfcAnalysisTheoryTypeEnum',
  IFCANGULARDIMENSION: 'IfcAngularDimension',
  IFCANGULARVELOCITYMEASURE: 'IfcAngularVelocityMeasure',
  IFCANNOTATION: 'IfcAnnotation',
  IFCANNOTATIONCURVEOCCURRENCE: 'IfcAnnotationCurveOccurrence',
  IFCANNOTATIONFILLAREA: 'IfcAnnotationFillArea',
  IFCANNOTATIONFILLAREAOCCURRENCE: 'IfcAnnotationFillAreaOccurrence',
  IFCANNOTATIONOCCURRENCE: 'IfcAnnotationOccurrence',
  IFCANNOTATIONSURFACE: 'IfcAnnotationSurface',
  IFCANNOTATIONSURFACEOCCURRENCE: 'IfcAnnotationSurfaceOccurrence',
  IFCANNOTATIONSYMBOLOCCURRENCE: 'IfcAnnotationSymbolOccurrence',
  IFCANNOTATIONTEXTOCCURRENCE: 'IfcAnnotationTextOccurrence',
  IFCANNOTATIONTYPEENUM: 'IfcAnnotationTypeEnum',
  IFCAPPLICATION: 'IfcApplication',
  IFCAPPLIEDVALUE: 'IfcAppliedValue',
  IFCAPPLIEDVALUERELATIONSHIP: 'IfcAppliedValueRelationship',
  IFCAPPROVAL: 'IfcApproval',
  IFCAPPROVALACTORRELATIONSHIP: 'IfcApprovalActorRelationship',
  IFCAPPROVALPROPERTYRELATIONSHIP: 'IfcApprovalPropertyRelationship',
  IFCAPPROVALRELATIONSHIP: 'IfcApprovalRelationship',
  IFCARBITRARYCLOSEDPROFILEDEF: 'IfcArbitraryClosedProfileDef',
  IFCARBITRARYOPENPROFILEDEF: 'IfcArbitraryOpenProfileDef',
  IFCARBITRARYPROFILEDEFWITHVOIDS: 'IfcArbitraryProfileDefWithVoids',
  IFCARCINDEX: 'IfcArcIndex',
  IFCAREADENSITYMEASURE: 'IfcAreaDensityMeasure',
  IFCAREAMEASURE: 'IfcAreaMeasure',
  IFCARITHMETICOPERATORENUM: 'IfcArithmeticOperatorEnum',
  IFCASSEMBLYPLACEENUM: 'IfcAssemblyPlaceEnum',
  IFCASSET: 'IfcAsset',
  IFCASYMMETRICISHAPEPROFILEDEF: 'IfcAsymmetricIShapeProfileDef',
  IFCAUDIOVISUALAPPLIANCE: 'IfcAudioVisualAppliance',
  IFCAUDIOVISUALAPPLIANCETYPE: 'IfcAudioVisualApplianceType',
  IFCAUDIOVISUALAPPLIANCETYPEENUM: 'IfcAudioVisualApplianceTypeEnum',
  IFCAXIS: 'IfcAxis',
  IFCBSPLINECURVE: 'IfcBSplineCurve',
  IFCBSPLINECURVEFORM: 'IfcBSplineCurveForm',
  IFCBSPLINECURVEWITHKNOTS: 'IfcBSplineCurveWithKnots',
  IFCBSPLINESURFACE: 'IfcBSplineSurface',
  IFCBSPLINESURFACEFORM: 'IfcBSplineSurfaceForm',
  IFCBSPLINESURFACEWITHKNOTS: 'IfcBSplineSurfaceWithKnots',
  IFCBEAM: 'IfcBeam',
  IFCBEAMSTANDARDCASE: 'IfcBeamStandardCase',
  IFCBEAMTYPE: 'IfcBeamType',
  IFCBEAMTYPEENUM: 'IfcBeamTypeEnum',
  IFCBEARING: 'IfcBearing',
  IFCBEARINGTYPE: 'IfcBearingType',
  IFCBEARINGTYPEENUM: 'IfcBearingTypeEnum',
  IFCBENCHMARKENUM: 'IfcBenchmarkEnum',
  IFCBEZIERCURVE: 'IfcBezierCurve',
  IFCBINARY: 'IfcBinary',
  IFCBLOBTEXTURE: 'IfcBlobTexture',
  IFCBLOCK: 'IfcBlock',
  IFCBOILER: 'IfcBoiler',
  IFCBOILERTYPE: 'IfcBoilerType',
  IFCBOILERTYPEENUM: 'IfcBoilerTypeEnum',
  IFCBOOLEAN: 'IfcBoolean',
  IFCBOOLEANCLIPPINGRESULT: 'IfcBooleanClippingResult',
  IFCBOOLEANOPERATOR: 'IfcBooleanOperator',
  IFCBOOLEANRESULT: 'IfcBooleanResult',
  IFCBOREHOLE: 'IfcBorehole',
  IFCBOUNDARYCONDITION: 'IfcBoundaryCondition',
  IFCBOUNDARYCURVE: 'IfcBoundaryCurve',
  IFCBOUNDARYEDGECONDITION: 'IfcBoundaryEdgeCondition',
  IFCBOUNDARYFACECONDITION: 'IfcBoundaryFaceCondition',
  IFCBOUNDARYNODECONDITION: 'IfcBoundaryNodeCondition',
  IFCBOUNDARYNODECONDITIONWARPING: 'IfcBoundaryNodeConditionWarping',
  IFCBOUNDEDCURVE: 'IfcBoundedCurve',
  IFCBOUNDEDSURFACE: 'IfcBoundedSurface',
  IFCBOUNDINGBOX: 'IfcBoundingBox',
  IFCBOXALIGNMENT: 'IfcBoxAlignment',
  IFCBOXEDHALFSPACE: 'IfcBoxedHalfSpace',
  IFCBRIDGE: 'IfcBridge',
  IFCBRIDGEPART: 'IfcBridgePart',
  IFCBRIDGEPARTTYPEENUM: 'IfcBridgePartTypeEnum',
  IFCBRIDGETYPEENUM: 'IfcBridgeTypeEnum',
  IFCBUILDING: 'IfcBuilding',
  IFCBUILDINGELEMENT: 'IfcBuildingElement',
  IFCBUILDINGELEMENTCOMPONENT: 'IfcBuildingElementComponent',
  IFCBUILDINGELEMENTPART: 'IfcBuildingElementPart',
  IFCBUILDINGELEMENTPARTTYPE: 'IfcBuildingElementPartType',
  IFCBUILDINGELEMENTPARTTYPEENUM: 'IfcBuildingElementPartTypeEnum',
  IFCBUILDINGELEMENTPROXY: 'IfcBuildingElementProxy',
  IFCBUILDINGELEMENTPROXYTYPE: 'IfcBuildingElementProxyType',
  IFCBUILDINGELEMENTPROXYTYPEENUM: 'IfcBuildingElementProxyTypeEnum',
  IFCBUILDINGELEMENTTYPE: 'IfcBuildingElementType',
  IFCBUILDINGSTOREY: 'IfcBuildingStorey',
  IFCBUILDINGSYSTEM: 'IfcBuildingSystem',
  IFCBUILDINGSYSTEMTYPEENUM: 'IfcBuildingSystemTypeEnum',
  IFCBUILTELEMENT: 'IfcBuiltElement',
  IFCBUILTELEMENTTYPE: 'IfcBuiltElementType',
  IFCBUILTSYSTEM: 'IfcBuiltSystem',
  IFCBUILTSYSTEMTYPEENUM: 'IfcBuiltSystemTypeEnum',
  IFCBURNER: 'IfcBurner',
  IFCBURNERTYPE: 'IfcBurnerType',
  IFCBURNERTYPEENUM: 'IfcBurnerTypeEnum',
  IFCCSHAPEPROFILEDEF: 'IfcCShapeProfileDef',
  IFCCABLECARRIERFITTING: 'IfcCableCarrierFitting',
  IFCCABLECARRIERFITTINGTYPE: 'IfcCableCarrierFittingType',
  IFCCABLECARRIERFITTINGTYPEENUM: 'IfcCableCarrierFittingTypeEnum',
  IFCCABLECARRIERSEGMENT: 'IfcCableCarrierSegment',
  IFCCABLECARRIERSEGMENTTYPE: 'IfcCableCarrierSegmentType',
  IFCCABLECARRIERSEGMENTTYPEENUM: 'IfcCableCarrierSegmentTypeEnum',
  IFCCABLEFITTING: 'IfcCableFitting',
  IFCCABLEFITTINGTYPE: 'IfcCableFittingType',
  IFCCABLEFITTINGTYPEENUM: 'IfcCableFittingTypeEnum',
  IFCCABLESEGMENT: 'IfcCableSegment',
  IFCCABLESEGMENTTYPE: 'IfcCableSegmentType',
  IFCCABLESEGMENTTYPEENUM: 'IfcCableSegmentTypeEnum',
  IFCCAISSONFOUNDATION: 'IfcCaissonFoundation',
  IFCCAISSONFOUNDATIONTYPE: 'IfcCaissonFoundationType',
  IFCCAISSONFOUNDATIONTYPEENUM: 'IfcCaissonFoundationTypeEnum',
  IFCCALENDARDATE: 'IfcCalendarDate',
  IFCCARDINALPOINTREFERENCE: 'IfcCardinalPointReference',
  IFCCARTESIANPOINT: 'IfcCartesianPoint',
  IFCCARTESIANPOINTLIST: 'IfcCartesianPointList',
  IFCCARTESIANTRANSFORMATIONOPERATOR: 'IfcCartesianTransformationOperator',
  IFCCENTERLINEPROFILEDEF: 'IfcCenterLineProfileDef',
  IFCCHAMFEREDGEFEATURE: 'IfcChamferEdgeFeature',
  IFCCHANGEACTIONENUM: 'IfcChangeActionEnum',
  IFCCHILLER: 'IfcChiller',
  IFCCHILLERTYPE: 'IfcChillerType',
  IFCCHILLERTYPEENUM: 'IfcChillerTypeEnum',
  IFCCHIMNEY: 'IfcChimney',
  IFCCHIMNEYTYPE: 'IfcChimneyType',
  IFCCHIMNEYTYPEENUM: 'IfcChimneyTypeEnum',
  IFCCIRCLE: 'IfcCircle',
  IFCCIRCLEHOLLOWPROFILEDEF: 'IfcCircleHollowProfileDef',
  IFCCIRCLEPROFILEDEF: 'IfcCircleProfileDef',
  IFCCIVILELEMENT: 'IfcCivilElement',
  IFCCIVILELEMENTTYPE: 'IfcCivilElementType',
  IFCCLASSIFICATION: 'IfcClassification',
  IFCCLASSIFICATIONITEM: 'IfcClassificationItem',
  IFCCLASSIFICATIONITEMRELATIONSHIP: 'IfcClassificationItemRelationship',
  IFCCLASSIFICATIONNOTATION: 'IfcClassificationNotation',
  IFCCLASSIFICATIONNOTATIONFACET: 'IfcClassificationNotationFacet',
  IFCCLASSIFICATIONREFERENCE: 'IfcClassificationReference',
  IFCCLOSEDSHELL: 'IfcClosedShell',
  IFCCLOTHOID: 'IfcClothoid',
  IFCCOIL: 'IfcCoil',
  IFCCOILTYPE: 'IfcCoilType',
  IFCCOILTYPEENUM: 'IfcCoilTypeEnum',
  IFCCOLOURRGB: 'IfcColourRgb',
  IFCCOLOURRGBLIST: 'IfcColourRgbList',
  IFCCOLOURSPECIFICATION: 'IfcColourSpecification',
  IFCCOLUMN: 'IfcColumn',
  IFCCOLUMNSTANDARDCASE: 'IfcColumnStandardCase',
  IFCCOLUMNTYPE: 'IfcColumnType',
  IFCCOLUMNTYPEENUM: 'IfcColumnTypeEnum',
  IFCCOMMUNICATIONSAPPLIANCE: 'IfcCommunicationsAppliance',
  IFCCOMMUNICATIONSAPPLIANCETYPE: 'IfcCommunicationsApplianceType',
  IFCCOMMUNICATIONSAPPLIANCETYPEENUM: 'IfcCommunicationsApplianceTypeEnum',
  IFCCOMPLEXNUMBER: 'IfcComplexNumber',
  IFCCOMPLEXPROPERTY: 'IfcComplexProperty',
  IFCCOMPLEXPROPERTYTEMPLATE: 'IfcComplexPropertyTemplate',
  IFCCOMPLEXPROPERTYTEMPLATETYPEENUM: 'IfcComplexPropertyTemplateTypeEnum',
  IFCCOMPOSITECURVE: 'IfcCompositeCurve',
  IFCCOMPOSITECURVEONSURFACE: 'IfcCompositeCurveOnSurface',
  IFCCOMPOSITECURVESEGMENT: 'IfcCompositeCurveSegment',
  IFCCOMPOSITEPROFILEDEF: 'IfcCompositeProfileDef',
  IFCCOMPOUNDPLANEANGLEMEASURE: 'IfcCompoundPlaneAngleMeasure',
  IFCCOMPRESSOR: 'IfcCompressor',
  IFCCOMPRESSORTYPE: 'IfcCompressorType',
  IFCCOMPRESSORTYPEENUM: 'IfcCompressorTypeEnum',
  IFCCONDENSER: 'IfcCondenser',
  IFCCONDENSERTYPE: 'IfcCondenserType',
  IFCCONDENSERTYPEENUM: 'IfcCondenserTypeEnum',
  IFCCONDITION: 'IfcCondition',
  IFCCONDITIONCRITERION: 'IfcConditionCriterion',
  IFCCONIC: 'IfcConic',
  IFCCONNECTEDFACESET: 'IfcConnectedFaceSet',
  IFCCONNECTIONCURVEGEOMETRY: 'IfcConnectionCurveGeometry',
  IFCCONNECTIONGEOMETRY: 'IfcConnectionGeometry',
  IFCCONNECTIONPOINTECCENTRICITY: 'IfcConnectionPointEccentricity',
  IFCCONNECTIONPOINTGEOMETRY: 'IfcConnectionPointGeometry',
  IFCCONNECTIONPORTGEOMETRY: 'IfcConnectionPortGeometry',
  IFCCONNECTIONSURFACEGEOMETRY: 'IfcConnectionSurfaceGeometry',
  IFCCONNECTIONTYPEENUM: 'IfcConnectionTypeEnum',
  IFCCONNECTIONVOLUMEGEOMETRY: 'IfcConnectionVolumeGeometry',
  IFCCONSTRAINT: 'IfcConstraint',
  IFCCONSTRAINTAGGREGATIONRELATIONSHIP: 'IfcConstraintAggregationRelationship',
  IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP: 'IfcConstraintClassificationRelationship',
  IFCCONSTRAINTENUM: 'IfcConstraintEnum',
  IFCCONSTRAINTRELATIONSHIP: 'IfcConstraintRelationship',
  IFCCONSTRUCTIONEQUIPMENTRESOURCE: 'IfcConstructionEquipmentResource',
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE: 'IfcConstructionEquipmentResourceType',
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPEENUM: 'IfcConstructionEquipmentResourceTypeEnum',
  IFCCONSTRUCTIONMATERIALRESOURCE: 'IfcConstructionMaterialResource',
  IFCCONSTRUCTIONMATERIALRESOURCETYPE: 'IfcConstructionMaterialResourceType',
  IFCCONSTRUCTIONMATERIALRESOURCETYPEENUM: 'IfcConstructionMaterialResourceTypeEnum',
  IFCCONSTRUCTIONPRODUCTRESOURCE: 'IfcConstructionProductResource',
  IFCCONSTRUCTIONPRODUCTRESOURCETYPE: 'IfcConstructionProductResourceType',
  IFCCONSTRUCTIONPRODUCTRESOURCETYPEENUM: 'IfcConstructionProductResourceTypeEnum',
  IFCCONSTRUCTIONRESOURCE: 'IfcConstructionResource',
  IFCCONSTRUCTIONRESOURCETYPE: 'IfcConstructionResourceType',
  IFCCONTEXT: 'IfcContext',
  IFCCONTEXTDEPENDENTMEASURE: 'IfcContextDependentMeasure',
  IFCCONTEXTDEPENDENTUNIT: 'IfcContextDependentUnit',
  IFCCONTROL: 'IfcControl',
  IFCCONTROLLER: 'IfcController',
  IFCCONTROLLERTYPE: 'IfcControllerType',
  IFCCONTROLLERTYPEENUM: 'IfcControllerTypeEnum',
  IFCCONVERSIONBASEDUNIT: 'IfcConversionBasedUnit',
  IFCCONVERSIONBASEDUNITWITHOFFSET: 'IfcConversionBasedUnitWithOffset',
  IFCCONVEYORSEGMENT: 'IfcConveyorSegment',
  IFCCONVEYORSEGMENTTYPE: 'IfcConveyorSegmentType',
  IFCCONVEYORSEGMENTTYPEENUM: 'IfcConveyorSegmentTypeEnum',
  IFCCOOLEDBEAM: 'IfcCooledBeam',
  IFCCOOLEDBEAMTYPE: 'IfcCooledBeamType',
  IFCCOOLEDBEAMTYPEENUM: 'IfcCooledBeamTypeEnum',
  IFCCOOLINGTOWER: 'IfcCoolingTower',
  IFCCOOLINGTOWERTYPE: 'IfcCoolingTowerType',
  IFCCOOLINGTOWERTYPEENUM: 'IfcCoolingTowerTypeEnum',
  IFCCOORDINATEOPERATION: 'IfcCoordinateOperation',
  IFCCOORDINATEREFERENCESYSTEM: 'IfcCoordinateReferenceSystem',
  IFCCOORDINATEDUNIVERSALTIMEOFFSET: 'IfcCoordinatedUniversalTimeOffset',
  IFCCOSINESPIRAL: 'IfcCosineSpiral',
  IFCCOSTITEM: 'IfcCostItem',
  IFCCOSTITEMTYPEENUM: 'IfcCostItemTypeEnum',
  IFCCOSTSCHEDULE: 'IfcCostSchedule',
  IFCCOSTSCHEDULETYPEENUM: 'IfcCostScheduleTypeEnum',
  IFCCOSTVALUE: 'IfcCostValue',
  IFCCOUNTMEASURE: 'IfcCountMeasure',
  IFCCOURSE: 'IfcCourse',
  IFCCOURSETYPE: 'IfcCourseType',
  IFCCOURSETYPEENUM: 'IfcCourseTypeEnum',
  IFCCOVERING: 'IfcCovering',
  IFCCOVERINGTYPE: 'IfcCoveringType',
  IFCCOVERINGTYPEENUM: 'IfcCoveringTypeEnum',
  IFCCRANERAILASHAPEPROFILEDEF: 'IfcCraneRailAShapeProfileDef',
  IFCCRANERAILFSHAPEPROFILEDEF: 'IfcCraneRailFShapeProfileDef',
  IFCCREWRESOURCE: 'IfcCrewResource',
  IFCCREWRESOURCETYPE: 'IfcCrewResourceType',
  IFCCREWRESOURCETYPEENUM: 'IfcCrewResourceTypeEnum',
  IFCCSGPRIMITIVE: 'IfcCsgPrimitive',
  IFCCSGSOLID: 'IfcCsgSolid',
  IFCCURRENCYENUM: 'IfcCurrencyEnum',
  IFCCURRENCYRELATIONSHIP: 'IfcCurrencyRelationship',
  IFCCURTAINWALL: 'IfcCurtainWall',
  IFCCURTAINWALLTYPE: 'IfcCurtainWallType',
  IFCCURTAINWALLTYPEENUM: 'IfcCurtainWallTypeEnum',
  IFCCURVATUREMEASURE: 'IfcCurvatureMeasure',
  IFCCURVE: 'IfcCurve',
  IFCCURVEBOUNDEDPLANE: 'IfcCurveBoundedPlane',
  IFCCURVEBOUNDEDSURFACE: 'IfcCurveBoundedSurface',
  IFCCURVEINTERPOLATIONENUM: 'IfcCurveInterpolationEnum',
  IFCCURVESEGMENT: 'IfcCurveSegment',
  IFCCURVESTYLE: 'IfcCurveStyle',
  IFCCURVESTYLEFONT: 'IfcCurveStyleFont',
  IFCCURVESTYLEFONTANDSCALING: 'IfcCurveStyleFontAndScaling',
  IFCCURVESTYLEFONTPATTERN: 'IfcCurveStyleFontPattern',
  IFCCYLINDRICALSURFACE: 'IfcCylindricalSurface',
  IFCDAMPER: 'IfcDamper',
  IFCDAMPERTYPE: 'IfcDamperType',
  IFCDAMPERTYPEENUM: 'IfcDamperTypeEnum',
  IFCDATAORIGINENUM: 'IfcDataOriginEnum',
  IFCDATE: 'IfcDate',
  IFCDATEANDTIME: 'IfcDateAndTime',
  IFCDATETIME: 'IfcDateTime',
  IFCDAYINMONTHNUMBER: 'IfcDayInMonthNumber',
  IFCDAYINWEEKNUMBER: 'IfcDayInWeekNumber',
  IFCDAYLIGHTSAVINGHOUR: 'IfcDaylightSavingHour',
  IFCDEEPFOUNDATION: 'IfcDeepFoundation',
  IFCDEEPFOUNDATIONTYPE: 'IfcDeepFoundationType',
  IFCDEFINEDSYMBOL: 'IfcDefinedSymbol',
  IFCDERIVEDPROFILEDEF: 'IfcDerivedProfileDef',
  IFCDERIVEDUNIT: 'IfcDerivedUnit',
  IFCDERIVEDUNITELEMENT: 'IfcDerivedUnitElement',
  IFCDERIVEDUNITENUM: 'IfcDerivedUnitEnum',
  IFCDESCRIPTIVEMEASURE: 'IfcDescriptiveMeasure',
  IFCDIAMETERDIMENSION: 'IfcDiameterDimension',
  IFCDIMENSIONCALLOUTRELATIONSHIP: 'IfcDimensionCalloutRelationship',
  IFCDIMENSIONCOUNT: 'IfcDimensionCount',
  IFCDIMENSIONCURVE: 'IfcDimensionCurve',
  IFCDIMENSIONCURVEDIRECTEDCALLOUT: 'IfcDimensionCurveDirectedCallout',
  IFCDIMENSIONCURVETERMINATOR: 'IfcDimensionCurveTerminator',
  IFCDIMENSIONEXTENTUSAGE: 'IfcDimensionExtentUsage',
  IFCDIMENSIONPAIR: 'IfcDimensionPair',
  IFCDIMENSIONALEXPONENTS: 'IfcDimensionalExponents',
  IFCDIRECTION: 'IfcDirection',
  IFCDIRECTIONSENSEENUM: 'IfcDirectionSenseEnum',
  IFCDIRECTRIXCURVESWEPTAREASOLID: 'IfcDirectrixCurveSweptAreaSolid',
  IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID: 'IfcDirectrixDerivedReferenceSweptAreaSolid',
  IFCDISCRETEACCESSORY: 'IfcDiscreteAccessory',
  IFCDISCRETEACCESSORYTYPE: 'IfcDiscreteAccessoryType',
  IFCDISCRETEACCESSORYTYPEENUM: 'IfcDiscreteAccessoryTypeEnum',
  IFCDISTRIBUTIONBOARD: 'IfcDistributionBoard',
  IFCDISTRIBUTIONBOARDTYPE: 'IfcDistributionBoardType',
  IFCDISTRIBUTIONBOARDTYPEENUM: 'IfcDistributionBoardTypeEnum',
  IFCDISTRIBUTIONCHAMBERELEMENT: 'IfcDistributionChamberElement',
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE: 'IfcDistributionChamberElementType',
  IFCDISTRIBUTIONCHAMBERELEMENTTYPEENUM: 'IfcDistributionChamberElementTypeEnum',
  IFCDISTRIBUTIONCIRCUIT: 'IfcDistributionCircuit',
  IFCDISTRIBUTIONCONTROLELEMENT: 'IfcDistributionControlElement',
  IFCDISTRIBUTIONCONTROLELEMENTTYPE: 'IfcDistributionControlElementType',
  IFCDISTRIBUTIONELEMENT: 'IfcDistributionElement',
  IFCDISTRIBUTIONELEMENTTYPE: 'IfcDistributionElementType',
  IFCDISTRIBUTIONFLOWELEMENT: 'IfcDistributionFlowElement',
  IFCDISTRIBUTIONFLOWELEMENTTYPE: 'IfcDistributionFlowElementType',
  IFCDISTRIBUTIONPORT: 'IfcDistributionPort',
  IFCDISTRIBUTIONPORTTYPEENUM: 'IfcDistributionPortTypeEnum',
  IFCDISTRIBUTIONSYSTEM: 'IfcDistributionSystem',
  IFCDISTRIBUTIONSYSTEMENUM: 'IfcDistributionSystemEnum',
  IFCDOCUMENTCONFIDENTIALITYENUM: 'IfcDocumentConfidentialityEnum',
  IFCDOCUMENTELECTRONICFORMAT: 'IfcDocumentElectronicFormat',
  IFCDOCUMENTINFORMATION: 'IfcDocumentInformation',
  IFCDOCUMENTINFORMATIONRELATIONSHIP: 'IfcDocumentInformationRelationship',
  IFCDOCUMENTREFERENCE: 'IfcDocumentReference',
  IFCDOCUMENTSTATUSENUM: 'IfcDocumentStatusEnum',
  IFCDOOR: 'IfcDoor',
  IFCDOORLININGPROPERTIES: 'IfcDoorLiningProperties',
  IFCDOORPANELOPERATIONENUM: 'IfcDoorPanelOperationEnum',
  IFCDOORPANELPOSITIONENUM: 'IfcDoorPanelPositionEnum',
  IFCDOORPANELPROPERTIES: 'IfcDoorPanelProperties',
  IFCDOORSTANDARDCASE: 'IfcDoorStandardCase',
  IFCDOORSTYLE: 'IfcDoorStyle',
  IFCDOORSTYLECONSTRUCTIONENUM: 'IfcDoorStyleConstructionEnum',
  IFCDOORSTYLEOPERATIONENUM: 'IfcDoorStyleOperationEnum',
  IFCDOORTYPE: 'IfcDoorType',
  IFCDOORTYPEENUM: 'IfcDoorTypeEnum',
  IFCDOORTYPEOPERATIONENUM: 'IfcDoorTypeOperationEnum',
  IFCDOSEEQUIVALENTMEASURE: 'IfcDoseEquivalentMeasure',
  IFCDRAUGHTINGCALLOUT: 'IfcDraughtingCallout',
  IFCDRAUGHTINGCALLOUTRELATIONSHIP: 'IfcDraughtingCalloutRelationship',
  IFCDRAUGHTINGPREDEFINEDCOLOUR: 'IfcDraughtingPreDefinedColour',
  IFCDRAUGHTINGPREDEFINEDCURVEFONT: 'IfcDraughtingPreDefinedCurveFont',
  IFCDRAUGHTINGPREDEFINEDTEXTFONT: 'IfcDraughtingPreDefinedTextFont',
  IFCDUCTFITTING: 'IfcDuctFitting',
  IFCDUCTFITTINGTYPE: 'IfcDuctFittingType',
  IFCDUCTFITTINGTYPEENUM: 'IfcDuctFittingTypeEnum',
  IFCDUCTSEGMENT: 'IfcDuctSegment',
  IFCDUCTSEGMENTTYPE: 'IfcDuctSegmentType',
  IFCDUCTSEGMENTTYPEENUM: 'IfcDuctSegmentTypeEnum',
  IFCDUCTSILENCER: 'IfcDuctSilencer',
  IFCDUCTSILENCERTYPE: 'IfcDuctSilencerType',
  IFCDUCTSILENCERTYPEENUM: 'IfcDuctSilencerTypeEnum',
  IFCDURATION: 'IfcDuration',
  IFCDYNAMICVISCOSITYMEASURE: 'IfcDynamicViscosityMeasure',
  IFCEARTHWORKSCUT: 'IfcEarthworksCut',
  IFCEARTHWORKSCUTTYPEENUM: 'IfcEarthworksCutTypeEnum',
  IFCEARTHWORKSELEMENT: 'IfcEarthworksElement',
  IFCEARTHWORKSFILL: 'IfcEarthworksFill',
  IFCEARTHWORKSFILLTYPEENUM: 'IfcEarthworksFillTypeEnum',
  IFCEDGE: 'IfcEdge',
  IFCEDGECURVE: 'IfcEdgeCurve',
  IFCEDGEFEATURE: 'IfcEdgeFeature',
  IFCEDGELOOP: 'IfcEdgeLoop',
  IFCELECTRICAPPLIANCE: 'IfcElectricAppliance',
  IFCELECTRICAPPLIANCETYPE: 'IfcElectricApplianceType',
  IFCELECTRICAPPLIANCETYPEENUM: 'IfcElectricApplianceTypeEnum',
  IFCELECTRICCAPACITANCEMEASURE: 'IfcElectricCapacitanceMeasure',
  IFCELECTRICCHARGEMEASURE: 'IfcElectricChargeMeasure',
  IFCELECTRICCONDUCTANCEMEASURE: 'IfcElectricConductanceMeasure',
  IFCELECTRICCURRENTENUM: 'IfcElectricCurrentEnum',
  IFCELECTRICCURRENTMEASURE: 'IfcElectricCurrentMeasure',
  IFCELECTRICDISTRIBUTIONBOARD: 'IfcElectricDistributionBoard',
  IFCELECTRICDISTRIBUTIONBOARDTYPE: 'IfcElectricDistributionBoardType',
  IFCELECTRICDISTRIBUTIONBOARDTYPEENUM: 'IfcElectricDistributionBoardTypeEnum',
  IFCELECTRICDISTRIBUTIONPOINT: 'IfcElectricDistributionPoint',
  IFCELECTRICDISTRIBUTIONPOINTFUNCTIONENUM: 'IfcElectricDistributionPointFunctionEnum',
  IFCELECTRICFLOWSTORAGEDEVICE: 'IfcElectricFlowStorageDevice',
  IFCELECTRICFLOWSTORAGEDEVICETYPE: 'IfcElectricFlowStorageDeviceType',
  IFCELECTRICFLOWSTORAGEDEVICETYPEENUM: 'IfcElectricFlowStorageDeviceTypeEnum',
  IFCELECTRICFLOWTREATMENTDEVICE: 'IfcElectricFlowTreatmentDevice',
  IFCELECTRICFLOWTREATMENTDEVICETYPE: 'IfcElectricFlowTreatmentDeviceType',
  IFCELECTRICFLOWTREATMENTDEVICETYPEENUM: 'IfcElectricFlowTreatmentDeviceTypeEnum',
  IFCELECTRICGENERATOR: 'IfcElectricGenerator',
  IFCELECTRICGENERATORTYPE: 'IfcElectricGeneratorType',
  IFCELECTRICGENERATORTYPEENUM: 'IfcElectricGeneratorTypeEnum',
  IFCELECTRICHEATERTYPE: 'IfcElectricHeaterType',
  IFCELECTRICHEATERTYPEENUM: 'IfcElectricHeaterTypeEnum',
  IFCELECTRICMOTOR: 'IfcElectricMotor',
  IFCELECTRICMOTORTYPE: 'IfcElectricMotorType',
  IFCELECTRICMOTORTYPEENUM: 'IfcElectricMotorTypeEnum',
  IFCELECTRICRESISTANCEMEASURE: 'IfcElectricResistanceMeasure',
  IFCELECTRICTIMECONTROL: 'IfcElectricTimeControl',
  IFCELECTRICTIMECONTROLTYPE: 'IfcElectricTimeControlType',
  IFCELECTRICTIMECONTROLTYPEENUM: 'IfcElectricTimeControlTypeEnum',
  IFCELECTRICVOLTAGEMEASURE: 'IfcElectricVoltageMeasure',
  IFCELECTRICALBASEPROPERTIES: 'IfcElectricalBaseProperties',
  IFCELECTRICALCIRCUIT: 'IfcElectricalCircuit',
  IFCELECTRICALELEMENT: 'IfcElectricalElement',
  IFCELEMENT: 'IfcElement',
  IFCELEMENTASSEMBLY: 'IfcElementAssembly',
  IFCELEMENTASSEMBLYTYPE: 'IfcElementAssemblyType',
  IFCELEMENTASSEMBLYTYPEENUM: 'IfcElementAssemblyTypeEnum',
  IFCELEMENTCOMPONENT: 'IfcElementComponent',
  IFCELEMENTCOMPONENTTYPE: 'IfcElementComponentType',
  IFCELEMENTCOMPOSITIONENUM: 'IfcElementCompositionEnum',
  IFCELEMENTQUANTITY: 'IfcElementQuantity',
  IFCELEMENTTYPE: 'IfcElementType',
  IFCELEMENTARYSURFACE: 'IfcElementarySurface',
  IFCELLIPSE: 'IfcEllipse',
  IFCELLIPSEPROFILEDEF: 'IfcEllipseProfileDef',
  IFCENERGYCONVERSIONDEVICE: 'IfcEnergyConversionDevice',
  IFCENERGYCONVERSIONDEVICETYPE: 'IfcEnergyConversionDeviceType',
  IFCENERGYMEASURE: 'IfcEnergyMeasure',
  IFCENERGYPROPERTIES: 'IfcEnergyProperties',
  IFCENERGYSEQUENCEENUM: 'IfcEnergySequenceEnum',
  IFCENGINE: 'IfcEngine',
  IFCENGINETYPE: 'IfcEngineType',
  IFCENGINETYPEENUM: 'IfcEngineTypeEnum',
  IFCENVIRONMENTALIMPACTCATEGORYENUM: 'IfcEnvironmentalImpactCategoryEnum',
  IFCENVIRONMENTALIMPACTVALUE: 'IfcEnvironmentalImpactValue',
  IFCEQUIPMENTELEMENT: 'IfcEquipmentElement',
  IFCEQUIPMENTSTANDARD: 'IfcEquipmentStandard',
  IFCEVAPORATIVECOOLER: 'IfcEvaporativeCooler',
  IFCEVAPORATIVECOOLERTYPE: 'IfcEvaporativeCoolerType',
  IFCEVAPORATIVECOOLERTYPEENUM: 'IfcEvaporativeCoolerTypeEnum',
  IFCEVAPORATOR: 'IfcEvaporator',
  IFCEVAPORATORTYPE: 'IfcEvaporatorType',
  IFCEVAPORATORTYPEENUM: 'IfcEvaporatorTypeEnum',
  IFCEVENT: 'IfcEvent',
  IFCEVENTTIME: 'IfcEventTime',
  IFCEVENTTRIGGERTYPEENUM: 'IfcEventTriggerTypeEnum',
  IFCEVENTTYPE: 'IfcEventType',
  IFCEVENTTYPEENUM: 'IfcEventTypeEnum',
  IFCEXTENDEDMATERIALPROPERTIES: 'IfcExtendedMaterialProperties',
  IFCEXTENDEDPROPERTIES: 'IfcExtendedProperties',
  IFCEXTERNALINFORMATION: 'IfcExternalInformation',
  IFCEXTERNALREFERENCE: 'IfcExternalReference',
  IFCEXTERNALREFERENCERELATIONSHIP: 'IfcExternalReferenceRelationship',
  IFCEXTERNALSPATIALELEMENT: 'IfcExternalSpatialElement',
  IFCEXTERNALSPATIALELEMENTTYPEENUM: 'IfcExternalSpatialElementTypeEnum',
  IFCEXTERNALSPATIALSTRUCTUREELEMENT: 'IfcExternalSpatialStructureElement',
  IFCEXTERNALLYDEFINEDHATCHSTYLE: 'IfcExternallyDefinedHatchStyle',
  IFCEXTERNALLYDEFINEDSURFACESTYLE: 'IfcExternallyDefinedSurfaceStyle',
  IFCEXTERNALLYDEFINEDSYMBOL: 'IfcExternallyDefinedSymbol',
  IFCEXTERNALLYDEFINEDTEXTFONT: 'IfcExternallyDefinedTextFont',
  IFCEXTRUDEDAREASOLID: 'IfcExtrudedAreaSolid',
  IFCEXTRUDEDAREASOLIDTAPERED: 'IfcExtrudedAreaSolidTapered',
  IFCFACE: 'IfcFace',
  IFCFACEBASEDSURFACEMODEL: 'IfcFaceBasedSurfaceModel',
  IFCFACEBOUND: 'IfcFaceBound',
  IFCFACEOUTERBOUND: 'IfcFaceOuterBound',
  IFCFACESURFACE: 'IfcFaceSurface',
  IFCFACETEDBREP: 'IfcFacetedBrep',
  IFCFACETEDBREPWITHVOIDS: 'IfcFacetedBrepWithVoids',
  IFCFACILITY: 'IfcFacility',
  IFCFACILITYPART: 'IfcFacilityPart',
  IFCFACILITYPARTCOMMON: 'IfcFacilityPartCommon',
  IFCFACILITYPARTCOMMONTYPEENUM: 'IfcFacilityPartCommonTypeEnum',
  IFCFACILITYUSAGEENUM: 'IfcFacilityUsageEnum',
  IFCFAILURECONNECTIONCONDITION: 'IfcFailureConnectionCondition',
  IFCFAN: 'IfcFan',
  IFCFANTYPE: 'IfcFanType',
  IFCFANTYPEENUM: 'IfcFanTypeEnum',
  IFCFASTENER: 'IfcFastener',
  IFCFASTENERTYPE: 'IfcFastenerType',
  IFCFASTENERTYPEENUM: 'IfcFastenerTypeEnum',
  IFCFEATUREELEMENT: 'IfcFeatureElement',
  IFCFEATUREELEMENTADDITION: 'IfcFeatureElementAddition',
  IFCFEATUREELEMENTSUBTRACTION: 'IfcFeatureElementSubtraction',
  IFCFILLAREASTYLE: 'IfcFillAreaStyle',
  IFCFILLAREASTYLEHATCHING: 'IfcFillAreaStyleHatching',
  IFCFILLAREASTYLETILESYMBOLWITHSTYLE: 'IfcFillAreaStyleTileSymbolWithStyle',
  IFCFILLAREASTYLETILES: 'IfcFillAreaStyleTiles',
  IFCFILTER: 'IfcFilter',
  IFCFILTERTYPE: 'IfcFilterType',
  IFCFILTERTYPEENUM: 'IfcFilterTypeEnum',
  IFCFIRESUPPRESSIONTERMINAL: 'IfcFireSuppressionTerminal',
  IFCFIRESUPPRESSIONTERMINALTYPE: 'IfcFireSuppressionTerminalType',
  IFCFIRESUPPRESSIONTERMINALTYPEENUM: 'IfcFireSuppressionTerminalTypeEnum',
  IFCFIXEDREFERENCESWEPTAREASOLID: 'IfcFixedReferenceSweptAreaSolid',
  IFCFLOWCONTROLLER: 'IfcFlowController',
  IFCFLOWCONTROLLERTYPE: 'IfcFlowControllerType',
  IFCFLOWDIRECTIONENUM: 'IfcFlowDirectionEnum',
  IFCFLOWFITTING: 'IfcFlowFitting',
  IFCFLOWFITTINGTYPE: 'IfcFlowFittingType',
  IFCFLOWINSTRUMENT: 'IfcFlowInstrument',
  IFCFLOWINSTRUMENTTYPE: 'IfcFlowInstrumentType',
  IFCFLOWINSTRUMENTTYPEENUM: 'IfcFlowInstrumentTypeEnum',
  IFCFLOWMETER: 'IfcFlowMeter',
  IFCFLOWMETERTYPE: 'IfcFlowMeterType',
  IFCFLOWMETERTYPEENUM: 'IfcFlowMeterTypeEnum',
  IFCFLOWMOVINGDEVICE: 'IfcFlowMovingDevice',
  IFCFLOWMOVINGDEVICETYPE: 'IfcFlowMovingDeviceType',
  IFCFLOWSEGMENT: 'IfcFlowSegment',
  IFCFLOWSEGMENTTYPE: 'IfcFlowSegmentType',
  IFCFLOWSTORAGEDEVICE: 'IfcFlowStorageDevice',
  IFCFLOWSTORAGEDEVICETYPE: 'IfcFlowStorageDeviceType',
  IFCFLOWTERMINAL: 'IfcFlowTerminal',
  IFCFLOWTERMINALTYPE: 'IfcFlowTerminalType',
  IFCFLOWTREATMENTDEVICE: 'IfcFlowTreatmentDevice',
  IFCFLOWTREATMENTDEVICETYPE: 'IfcFlowTreatmentDeviceType',
  IFCFLUIDFLOWPROPERTIES: 'IfcFluidFlowProperties',
  IFCFONTSTYLE: 'IfcFontStyle',
  IFCFONTVARIANT: 'IfcFontVariant',
  IFCFONTWEIGHT: 'IfcFontWeight',
  IFCFOOTING: 'IfcFooting',
  IFCFOOTINGTYPE: 'IfcFootingType',
  IFCFOOTINGTYPEENUM: 'IfcFootingTypeEnum',
  IFCFORCEMEASURE: 'IfcForceMeasure',
  IFCFREQUENCYMEASURE: 'IfcFrequencyMeasure',
  IFCFUELPROPERTIES: 'IfcFuelProperties',
  IFCFURNISHINGELEMENT: 'IfcFurnishingElement',
  IFCFURNISHINGELEMENTTYPE: 'IfcFurnishingElementType',
  IFCFURNITURE: 'IfcFurniture',
  IFCFURNITURESTANDARD: 'IfcFurnitureStandard',
  IFCFURNITURETYPE: 'IfcFurnitureType',
  IFCFURNITURETYPEENUM: 'IfcFurnitureTypeEnum',
  IFCGASTERMINALTYPE: 'IfcGasTerminalType',
  IFCGASTERMINALTYPEENUM: 'IfcGasTerminalTypeEnum',
  IFCGENERALMATERIALPROPERTIES: 'IfcGeneralMaterialProperties',
  IFCGENERALPROFILEPROPERTIES: 'IfcGeneralProfileProperties',
  IFCGEOGRAPHICCRS: 'IfcGeographicCRS',
  IFCGEOGRAPHICELEMENT: 'IfcGeographicElement',
  IFCGEOGRAPHICELEMENTTYPE: 'IfcGeographicElementType',
  IFCGEOGRAPHICELEMENTTYPEENUM: 'IfcGeographicElementTypeEnum',
  IFCGEOMETRICCURVESET: 'IfcGeometricCurveSet',
  IFCGEOMETRICPROJECTIONENUM: 'IfcGeometricProjectionEnum',
  IFCGEOMETRICREPRESENTATIONCONTEXT: 'IfcGeometricRepresentationContext',
  IFCGEOMETRICREPRESENTATIONITEM: 'IfcGeometricRepresentationItem',
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT: 'IfcGeometricRepresentationSubContext',
  IFCGEOMETRICSET: 'IfcGeometricSet',
  IFCGEOMODEL: 'IfcGeomodel',
  IFCGEOSLICE: 'IfcGeoslice',
  IFCGEOTECHNICALASSEMBLY: 'IfcGeotechnicalAssembly',
  IFCGEOTECHNICALELEMENT: 'IfcGeotechnicalElement',
  IFCGEOTECHNICALSTRATUM: 'IfcGeotechnicalStratum',
  IFCGEOTECHNICALSTRATUMTYPEENUM: 'IfcGeotechnicalStratumTypeEnum',
  IFCGLOBALORLOCALENUM: 'IfcGlobalOrLocalEnum',
  IFCGLOBALLYUNIQUEID: 'IfcGloballyUniqueId',
  IFCGRADIENTCURVE: 'IfcGradientCurve',
  IFCGRID: 'IfcGrid',
  IFCGRIDAXIS: 'IfcGridAxis',
  IFCGRIDPLACEMENT: 'IfcGridPlacement',
  IFCGRIDTYPEENUM: 'IfcGridTypeEnum',
  IFCGROUP: 'IfcGroup',
  IFCHALFSPACESOLID: 'IfcHalfSpaceSolid',
  IFCHEATEXCHANGER: 'IfcHeatExchanger',
  IFCHEATEXCHANGERTYPE: 'IfcHeatExchangerType',
  IFCHEATEXCHANGERTYPEENUM: 'IfcHeatExchangerTypeEnum',
  IFCHEATFLUXDENSITYMEASURE: 'IfcHeatFluxDensityMeasure',
  IFCHEATINGVALUEMEASURE: 'IfcHeatingValueMeasure',
  IFCHOURINDAY: 'IfcHourInDay',
  IFCHUMIDIFIER: 'IfcHumidifier',
  IFCHUMIDIFIERTYPE: 'IfcHumidifierType',
  IFCHUMIDIFIERTYPEENUM: 'IfcHumidifierTypeEnum',
  IFCHYGROSCOPICMATERIALPROPERTIES: 'IfcHygroscopicMaterialProperties',
  IFCISHAPEPROFILEDEF: 'IfcIShapeProfileDef',
  IFCIDENTIFIER: 'IfcIdentifier',
  IFCILLUMINANCEMEASURE: 'IfcIlluminanceMeasure',
  IFCIMAGETEXTURE: 'IfcImageTexture',
  IFCIMPACTPROTECTIONDEVICE: 'IfcImpactProtectionDevice',
  IFCIMPACTPROTECTIONDEVICETYPE: 'IfcImpactProtectionDeviceType',
  IFCIMPACTPROTECTIONDEVICETYPEENUM: 'IfcImpactProtectionDeviceTypeEnum',
  IFCINDEXEDCOLOURMAP: 'IfcIndexedColourMap',
  IFCINDEXEDPOLYCURVE: 'IfcIndexedPolyCurve',
  IFCINDEXEDPOLYGONALFACE: 'IfcIndexedPolygonalFace',
  IFCINDEXEDPOLYGONALFACEWITHVOIDS: 'IfcIndexedPolygonalFaceWithVoids',
  IFCINDEXEDPOLYGONALTEXTUREMAP: 'IfcIndexedPolygonalTextureMap',
  IFCINDEXEDTEXTUREMAP: 'IfcIndexedTextureMap',
  IFCINDEXEDTRIANGLETEXTUREMAP: 'IfcIndexedTriangleTextureMap',
  IFCINDUCTANCEMEASURE: 'IfcInductanceMeasure',
  IFCINTEGER: 'IfcInteger',
  IFCINTEGERCOUNTRATEMEASURE: 'IfcIntegerCountRateMeasure',
  IFCINTERCEPTOR: 'IfcInterceptor',
  IFCINTERCEPTORTYPE: 'IfcInterceptorType',
  IFCINTERCEPTORTYPEENUM: 'IfcInterceptorTypeEnum',
  IFCINTERNALOREXTERNALENUM: 'IfcInternalOrExternalEnum',
  IFCINTERSECTIONCURVE: 'IfcIntersectionCurve',
  IFCINVENTORY: 'IfcInventory',
  IFCINVENTORYTYPEENUM: 'IfcInventoryTypeEnum',
  IFCIONCONCENTRATIONMEASURE: 'IfcIonConcentrationMeasure',
  IFCIRREGULARTIMESERIES: 'IfcIrregularTimeSeries',
  IFCIRREGULARTIMESERIESVALUE: 'IfcIrregularTimeSeriesValue',
  IFCISOTHERMALMOISTURECAPACITYMEASURE: 'IfcIsothermalMoistureCapacityMeasure',
  IFCJUNCTIONBOX: 'IfcJunctionBox',
  IFCJUNCTIONBOXTYPE: 'IfcJunctionBoxType',
  IFCJUNCTIONBOXTYPEENUM: 'IfcJunctionBoxTypeEnum',
  IFCKERB: 'IfcKerb',
  IFCKERBTYPE: 'IfcKerbType',
  IFCKERBTYPEENUM: 'IfcKerbTypeEnum',
  IFCKINEMATICVISCOSITYMEASURE: 'IfcKinematicViscosityMeasure',
  IFCKNOTTYPE: 'IfcKnotType',
  IFCLSHAPEPROFILEDEF: 'IfcLShapeProfileDef',
  IFCLABEL: 'IfcLabel',
  IFCLABORRESOURCE: 'IfcLaborResource',
  IFCLABORRESOURCETYPE: 'IfcLaborResourceType',
  IFCLABORRESOURCETYPEENUM: 'IfcLaborResourceTypeEnum',
  IFCLAGTIME: 'IfcLagTime',
  IFCLAMP: 'IfcLamp',
  IFCLAMPTYPE: 'IfcLampType',
  IFCLAMPTYPEENUM: 'IfcLampTypeEnum',
  IFCLANGUAGEID: 'IfcLanguageId',
  IFCLAYERSETDIRECTIONENUM: 'IfcLayerSetDirectionEnum',
  IFCLENGTHMEASURE: 'IfcLengthMeasure',
  IFCLIBRARYINFORMATION: 'IfcLibraryInformation',
  IFCLIBRARYREFERENCE: 'IfcLibraryReference',
  IFCLIGHTDISTRIBUTIONCURVEENUM: 'IfcLightDistributionCurveEnum',
  IFCLIGHTDISTRIBUTIONDATA: 'IfcLightDistributionData',
  IFCLIGHTEMISSIONSOURCEENUM: 'IfcLightEmissionSourceEnum',
  IFCLIGHTFIXTURE: 'IfcLightFixture',
  IFCLIGHTFIXTURETYPE: 'IfcLightFixtureType',
  IFCLIGHTFIXTURETYPEENUM: 'IfcLightFixtureTypeEnum',
  IFCLIGHTINTENSITYDISTRIBUTION: 'IfcLightIntensityDistribution',
  IFCLIGHTSOURCE: 'IfcLightSource',
  IFCLIGHTSOURCEAMBIENT: 'IfcLightSourceAmbient',
  IFCLIGHTSOURCEDIRECTIONAL: 'IfcLightSourceDirectional',
  IFCLIGHTSOURCEGONIOMETRIC: 'IfcLightSourceGoniometric',
  IFCLIGHTSOURCEPOSITIONAL: 'IfcLightSourcePositional',
  IFCLIGHTSOURCESPOT: 'IfcLightSourceSpot',
  IFCLINE: 'IfcLine',
  IFCLINEINDEX: 'IfcLineIndex',
  IFCLINEOBJECT: 'IfcLineObject',
  IFCLINEARDIMENSION: 'IfcLinearDimension',
  IFCLINEARELEMENT: 'IfcLinearElement',
  IFCLINEARFORCEMEASURE: 'IfcLinearForceMeasure',
  IFCLINEARMOMENTMEASURE: 'IfcLinearMomentMeasure',
  IFCLINEARPLACEMENT: 'IfcLinearPlacement',
  IFCLINEARPOSITIONINGELEMENT: 'IfcLinearPositioningElement',
  IFCLINEARSTIFFNESSMEASURE: 'IfcLinearStiffnessMeasure',
  IFCLINEARVELOCITYMEASURE: 'IfcLinearVelocityMeasure',
  IFCLIQUIDTERMINAL: 'IfcLiquidTerminal',
  IFCLIQUIDTERMINALTYPE: 'IfcLiquidTerminalType',
  IFCLIQUIDTERMINALTYPEENUM: 'IfcLiquidTerminalTypeEnum',
  IFCLOADGROUPTYPEENUM: 'IfcLoadGroupTypeEnum',
  IFCLOCALPLACEMENT: 'IfcLocalPlacement',
  IFCLOCALTIME: 'IfcLocalTime',
  IFCLOGICAL: 'IfcLogical',
  IFCLOGICALOPERATORENUM: 'IfcLogicalOperatorEnum',
  IFCLOOP: 'IfcLoop',
  IFCLUMINOUSFLUXMEASURE: 'IfcLuminousFluxMeasure',
  IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE: 'IfcLuminousIntensityDistributionMeasure',
  IFCLUMINOUSINTENSITYMEASURE: 'IfcLuminousIntensityMeasure',
  IFCMAGNETICFLUXDENSITYMEASURE: 'IfcMagneticFluxDensityMeasure',
  IFCMAGNETICFLUXMEASURE: 'IfcMagneticFluxMeasure',
  IFCMANIFOLDSOLIDBREP: 'IfcManifoldSolidBrep',
  IFCMAPCONVERSION: 'IfcMapConversion',
  IFCMAPCONVERSIONSCALED: 'IfcMapConversionScaled',
  IFCMAPPEDITEM: 'IfcMappedItem',
  IFCMARINEFACILITY: 'IfcMarineFacility',
  IFCMARINEFACILITYTYPEENUM: 'IfcMarineFacilityTypeEnum',
  IFCMARINEPART: 'IfcMarinePart',
  IFCMARINEPARTTYPEENUM: 'IfcMarinePartTypeEnum',
  IFCMASSDENSITYMEASURE: 'IfcMassDensityMeasure',
  IFCMASSFLOWRATEMEASURE: 'IfcMassFlowRateMeasure',
  IFCMASSMEASURE: 'IfcMassMeasure',
  IFCMASSPERLENGTHMEASURE: 'IfcMassPerLengthMeasure',
  IFCMATERIAL: 'IfcMaterial',
  IFCMATERIALCLASSIFICATIONRELATIONSHIP: 'IfcMaterialClassificationRelationship',
  IFCMATERIALCONSTITUENT: 'IfcMaterialConstituent',
  IFCMATERIALCONSTITUENTSET: 'IfcMaterialConstituentSet',
  IFCMATERIALDEFINITION: 'IfcMaterialDefinition',
  IFCMATERIALDEFINITIONREPRESENTATION: 'IfcMaterialDefinitionRepresentation',
  IFCMATERIALLAYER: 'IfcMaterialLayer',
  IFCMATERIALLAYERSET: 'IfcMaterialLayerSet',
  IFCMATERIALLAYERSETUSAGE: 'IfcMaterialLayerSetUsage',
  IFCMATERIALLAYERWITHOFFSETS: 'IfcMaterialLayerWithOffsets',
  IFCMATERIALLIST: 'IfcMaterialList',
  IFCMATERIALPROFILE: 'IfcMaterialProfile',
  IFCMATERIALPROFILESET: 'IfcMaterialProfileSet',
  IFCMATERIALPROFILESETUSAGE: 'IfcMaterialProfileSetUsage',
  IFCMATERIALPROFILESETUSAGETAPERING: 'IfcMaterialProfileSetUsageTapering',
  IFCMATERIALPROFILEWITHOFFSETS: 'IfcMaterialProfileWithOffsets',
  IFCMATERIALPROPERTIES: 'IfcMaterialProperties',
  IFCMATERIALRELATIONSHIP: 'IfcMaterialRelationship',
  IFCMATERIALUSAGEDEFINITION: 'IfcMaterialUsageDefinition',
  IFCMEASUREWITHUNIT: 'IfcMeasureWithUnit',
  IFCMECHANICALCONCRETEMATERIALPROPERTIES: 'IfcMechanicalConcreteMaterialProperties',
  IFCMECHANICALFASTENER: 'IfcMechanicalFastener',
  IFCMECHANICALFASTENERTYPE: 'IfcMechanicalFastenerType',
  IFCMECHANICALFASTENERTYPEENUM: 'IfcMechanicalFastenerTypeEnum',
  IFCMECHANICALMATERIALPROPERTIES: 'IfcMechanicalMaterialProperties',
  IFCMECHANICALSTEELMATERIALPROPERTIES: 'IfcMechanicalSteelMaterialProperties',
  IFCMEDICALDEVICE: 'IfcMedicalDevice',
  IFCMEDICALDEVICETYPE: 'IfcMedicalDeviceType',
  IFCMEDICALDEVICETYPEENUM: 'IfcMedicalDeviceTypeEnum',
  IFCMEMBER: 'IfcMember',
  IFCMEMBERSTANDARDCASE: 'IfcMemberStandardCase',
  IFCMEMBERTYPE: 'IfcMemberType',
  IFCMEMBERTYPEENUM: 'IfcMemberTypeEnum',
  IFCMETRIC: 'IfcMetric',
  IFCMINUTEINHOUR: 'IfcMinuteInHour',
  IFCMIRROREDPROFILEDEF: 'IfcMirroredProfileDef',
  IFCMOBILETELECOMMUNICATIONSAPPLIANCE: 'IfcMobileTelecommunicationsAppliance',
  IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE: 'IfcMobileTelecommunicationsApplianceType',
  IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPEENUM: 'IfcMobileTelecommunicationsApplianceTypeEnum',
  IFCMODULUSOFELASTICITYMEASURE: 'IfcModulusOfElasticityMeasure',
  IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE: 'IfcModulusOfLinearSubgradeReactionMeasure',
  IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE: 'IfcModulusOfRotationalSubgradeReactionMeasure',
  IFCMODULUSOFSUBGRADEREACTIONMEASURE: 'IfcModulusOfSubgradeReactionMeasure',
  IFCMOISTUREDIFFUSIVITYMEASURE: 'IfcMoistureDiffusivityMeasure',
  IFCMOLECULARWEIGHTMEASURE: 'IfcMolecularWeightMeasure',
  IFCMOMENTOFINERTIAMEASURE: 'IfcMomentOfInertiaMeasure',
  IFCMONETARYMEASURE: 'IfcMonetaryMeasure',
  IFCMONETARYUNIT: 'IfcMonetaryUnit',
  IFCMONTHINYEARNUMBER: 'IfcMonthInYearNumber',
  IFCMOORINGDEVICE: 'IfcMooringDevice',
  IFCMOORINGDEVICETYPE: 'IfcMooringDeviceType',
  IFCMOORINGDEVICETYPEENUM: 'IfcMooringDeviceTypeEnum',
  IFCMOTORCONNECTION: 'IfcMotorConnection',
  IFCMOTORCONNECTIONTYPE: 'IfcMotorConnectionType',
  IFCMOTORCONNECTIONTYPEENUM: 'IfcMotorConnectionTypeEnum',
  IFCMOVE: 'IfcMove',
  IFCNAMEDUNIT: 'IfcNamedUnit',
  IFCNAVIGATIONELEMENT: 'IfcNavigationElement',
  IFCNAVIGATIONELEMENTTYPE: 'IfcNavigationElementType',
  IFCNAVIGATIONELEMENTTYPEENUM: 'IfcNavigationElementTypeEnum',
  IFCNONNEGATIVELENGTHMEASURE: 'IfcNonNegativeLengthMeasure',
  IFCNORMALISEDRATIOMEASURE: 'IfcNormalisedRatioMeasure',
  IFCNULLSTYLE: 'IfcNullStyle',
  IFCNUMERICMEASURE: 'IfcNumericMeasure',
  IFCOBJECT: 'IfcObject',
  IFCOBJECTDEFINITION: 'IfcObjectDefinition',
  IFCOBJECTPLACEMENT: 'IfcObjectPlacement',
  IFCOBJECTTYPEENUM: 'IfcObjectTypeEnum',
  IFCOBJECTIVE: 'IfcObjective',
  IFCOBJECTIVEENUM: 'IfcObjectiveEnum',
  IFCOCCUPANT: 'IfcOccupant',
  IFCOCCUPANTTYPEENUM: 'IfcOccupantTypeEnum',
  IFCOFFSETCURVE: 'IfcOffsetCurve',
  IFCOFFSETCURVEBYDISTANCES: 'IfcOffsetCurveByDistances',
  IFCONEDIRECTIONREPEATFACTOR: 'IfcOneDirectionRepeatFactor',
  IFCOPENCROSSPROFILEDEF: 'IfcOpenCrossProfileDef',
  IFCOPENSHELL: 'IfcOpenShell',
  IFCOPENINGELEMENT: 'IfcOpeningElement',
  IFCOPENINGELEMENTTYPEENUM: 'IfcOpeningElementTypeEnum',
  IFCOPENINGSTANDARDCASE: 'IfcOpeningStandardCase',
  IFCOPTICALMATERIALPROPERTIES: 'IfcOpticalMaterialProperties',
  IFCORDERACTION: 'IfcOrderAction',
  IFCORGANIZATION: 'IfcOrganization',
  IFCORGANIZATIONRELATIONSHIP: 'IfcOrganizationRelationship',
  IFCORIENTEDEDGE: 'IfcOrientedEdge',
  IFCOUTERBOUNDARYCURVE: 'IfcOuterBoundaryCurve',
  IFCOUTLET: 'IfcOutlet',
  IFCOUTLETTYPE: 'IfcOutletType',
  IFCOUTLETTYPEENUM: 'IfcOutletTypeEnum',
  IFCOWNERHISTORY: 'IfcOwnerHistory',
  IFCPHMEASURE: 'IfcPHMeasure',
  IFCPARAMETERVALUE: 'IfcParameterValue',
  IFCPARAMETERIZEDPROFILEDEF: 'IfcParameterizedProfileDef',
  IFCPATH: 'IfcPath',
  IFCPAVEMENT: 'IfcPavement',
  IFCPAVEMENTTYPE: 'IfcPavementType',
  IFCPAVEMENTTYPEENUM: 'IfcPavementTypeEnum',
  IFCPCURVE: 'IfcPcurve',
  IFCPERFORMANCEHISTORY: 'IfcPerformanceHistory',
  IFCPERFORMANCEHISTORYTYPEENUM: 'IfcPerformanceHistoryTypeEnum',
  IFCPERMEABLECOVERINGOPERATIONENUM: 'IfcPermeableCoveringOperationEnum',
  IFCPERMEABLECOVERINGPROPERTIES: 'IfcPermeableCoveringProperties',
  IFCPERMIT: 'IfcPermit',
  IFCPERMITTYPEENUM: 'IfcPermitTypeEnum',
  IFCPERSON: 'IfcPerson',
  IFCPERSONANDORGANIZATION: 'IfcPersonAndOrganization',
  IFCPHYSICALCOMPLEXQUANTITY: 'IfcPhysicalComplexQuantity',
  IFCPHYSICALORVIRTUALENUM: 'IfcPhysicalOrVirtualEnum',
  IFCPHYSICALQUANTITY: 'IfcPhysicalQuantity',
  IFCPHYSICALSIMPLEQUANTITY: 'IfcPhysicalSimpleQuantity',
  IFCPILE: 'IfcPile',
  IFCPILECONSTRUCTIONENUM: 'IfcPileConstructionEnum',
  IFCPILETYPE: 'IfcPileType',
  IFCPILETYPEENUM: 'IfcPileTypeEnum',
  IFCPIPEFITTING: 'IfcPipeFitting',
  IFCPIPEFITTINGTYPE: 'IfcPipeFittingType',
  IFCPIPEFITTINGTYPEENUM: 'IfcPipeFittingTypeEnum',
  IFCPIPESEGMENT: 'IfcPipeSegment',
  IFCPIPESEGMENTTYPE: 'IfcPipeSegmentType',
  IFCPIPESEGMENTTYPEENUM: 'IfcPipeSegmentTypeEnum',
  IFCPIXELTEXTURE: 'IfcPixelTexture',
  IFCPLACEMENT: 'IfcPlacement',
  IFCPLANARBOX: 'IfcPlanarBox',
  IFCPLANAREXTENT: 'IfcPlanarExtent',
  IFCPLANARFORCEMEASURE: 'IfcPlanarForceMeasure',
  IFCPLANE: 'IfcPlane',
  IFCPLANEANGLEMEASURE: 'IfcPlaneAngleMeasure',
  IFCPLATE: 'IfcPlate',
  IFCPLATESTANDARDCASE: 'IfcPlateStandardCase',
  IFCPLATETYPE: 'IfcPlateType',
  IFCPLATETYPEENUM: 'IfcPlateTypeEnum',
  IFCPOINT: 'IfcPoint',
  IFCPOINTBYDISTANCEEXPRESSION: 'IfcPointByDistanceExpression',
  IFCPOINTONCURVE: 'IfcPointOnCurve',
  IFCPOINTONSURFACE: 'IfcPointOnSurface',
  IFCPOLYLOOP: 'IfcPolyLoop',
  IFCPOLYGONALBOUNDEDHALFSPACE: 'IfcPolygonalBoundedHalfSpace',
  IFCPOLYGONALFACESET: 'IfcPolygonalFaceSet',
  IFCPOLYLINE: 'IfcPolyline',
  IFCPOLYNOMIALCURVE: 'IfcPolynomialCurve',
  IFCPORT: 'IfcPort',
  IFCPOSITIONINGELEMENT: 'IfcPositioningElement',
  IFCPOSITIVEINTEGER: 'IfcPositiveInteger',
  IFCPOSITIVELENGTHMEASURE: 'IfcPositiveLengthMeasure',
  IFCPOSITIVEPLANEANGLEMEASURE: 'IfcPositivePlaneAngleMeasure',
  IFCPOSITIVERATIOMEASURE: 'IfcPositiveRatioMeasure',
  IFCPOSTALADDRESS: 'IfcPostalAddress',
  IFCPOWERMEASURE: 'IfcPowerMeasure',
  IFCPREDEFINEDCOLOUR: 'IfcPreDefinedColour',
  IFCPREDEFINEDCURVEFONT: 'IfcPreDefinedCurveFont',
  IFCPREDEFINEDDIMENSIONSYMBOL: 'IfcPreDefinedDimensionSymbol',
  IFCPREDEFINEDITEM: 'IfcPreDefinedItem',
  IFCPREDEFINEDPOINTMARKERSYMBOL: 'IfcPreDefinedPointMarkerSymbol',
  IFCPREDEFINEDPROPERTIES: 'IfcPreDefinedProperties',
  IFCPREDEFINEDPROPERTYSET: 'IfcPreDefinedPropertySet',
  IFCPREDEFINEDSYMBOL: 'IfcPreDefinedSymbol',
  IFCPREDEFINEDTERMINATORSYMBOL: 'IfcPreDefinedTerminatorSymbol',
  IFCPREDEFINEDTEXTFONT: 'IfcPreDefinedTextFont',
  IFCPREFERREDSURFACECURVEREPRESENTATION: 'IfcPreferredSurfaceCurveRepresentation',
  IFCPRESENTABLETEXT: 'IfcPresentableText',
  IFCPRESENTATIONITEM: 'IfcPresentationItem',
  IFCPRESENTATIONLAYERASSIGNMENT: 'IfcPresentationLayerAssignment',
  IFCPRESENTATIONLAYERWITHSTYLE: 'IfcPresentationLayerWithStyle',
  IFCPRESENTATIONSTYLE: 'IfcPresentationStyle',
  IFCPRESENTATIONSTYLEASSIGNMENT: 'IfcPresentationStyleAssignment',
  IFCPRESSUREMEASURE: 'IfcPressureMeasure',
  IFCPROCEDURE: 'IfcProcedure',
  IFCPROCEDURETYPE: 'IfcProcedureType',
  IFCPROCEDURETYPEENUM: 'IfcProcedureTypeEnum',
  IFCPROCESS: 'IfcProcess',
  IFCPRODUCT: 'IfcProduct',
  IFCPRODUCTDEFINITIONSHAPE: 'IfcProductDefinitionShape',
  IFCPRODUCTREPRESENTATION: 'IfcProductRepresentation',
  IFCPRODUCTSOFCOMBUSTIONPROPERTIES: 'IfcProductsOfCombustionProperties',
  IFCPROFILEDEF: 'IfcProfileDef',
  IFCPROFILEPROPERTIES: 'IfcProfileProperties',
  IFCPROFILETYPEENUM: 'IfcProfileTypeEnum',
  IFCPROJECT: 'IfcProject',
  IFCPROJECTLIBRARY: 'IfcProjectLibrary',
  IFCPROJECTORDER: 'IfcProjectOrder',
  IFCPROJECTORDERRECORD: 'IfcProjectOrderRecord',
  IFCPROJECTORDERRECORDTYPEENUM: 'IfcProjectOrderRecordTypeEnum',
  IFCPROJECTORDERTYPEENUM: 'IfcProjectOrderTypeEnum',
  IFCPROJECTEDCRS: 'IfcProjectedCRS',
  IFCPROJECTEDORTRUELENGTHENUM: 'IfcProjectedOrTrueLengthEnum',
  IFCPROJECTIONCURVE: 'IfcProjectionCurve',
  IFCPROJECTIONELEMENT: 'IfcProjectionElement',
  IFCPROJECTIONELEMENTTYPEENUM: 'IfcProjectionElementTypeEnum',
  IFCPROPERTY: 'IfcProperty',
  IFCPROPERTYABSTRACTION: 'IfcPropertyAbstraction',
  IFCPROPERTYBOUNDEDVALUE: 'IfcPropertyBoundedValue',
  IFCPROPERTYCONSTRAINTRELATIONSHIP: 'IfcPropertyConstraintRelationship',
  IFCPROPERTYDEFINITION: 'IfcPropertyDefinition',
  IFCPROPERTYDEPENDENCYRELATIONSHIP: 'IfcPropertyDependencyRelationship',
  IFCPROPERTYENUMERATEDVALUE: 'IfcPropertyEnumeratedValue',
  IFCPROPERTYENUMERATION: 'IfcPropertyEnumeration',
  IFCPROPERTYLISTVALUE: 'IfcPropertyListValue',
  IFCPROPERTYREFERENCEVALUE: 'IfcPropertyReferenceValue',
  IFCPROPERTYSET: 'IfcPropertySet',
  IFCPROPERTYSETDEFINITION: 'IfcPropertySetDefinition',
  IFCPROPERTYSETDEFINITIONSET: 'IfcPropertySetDefinitionSet',
  IFCPROPERTYSETTEMPLATE: 'IfcPropertySetTemplate',
  IFCPROPERTYSETTEMPLATETYPEENUM: 'IfcPropertySetTemplateTypeEnum',
  IFCPROPERTYSINGLEVALUE: 'IfcPropertySingleValue',
  IFCPROPERTYSOURCEENUM: 'IfcPropertySourceEnum',
  IFCPROPERTYTABLEVALUE: 'IfcPropertyTableValue',
  IFCPROPERTYTEMPLATE: 'IfcPropertyTemplate',
  IFCPROPERTYTEMPLATEDEFINITION: 'IfcPropertyTemplateDefinition',
  IFCPROTECTIVEDEVICE: 'IfcProtectiveDevice',
  IFCPROTECTIVEDEVICETRIPPINGUNIT: 'IfcProtectiveDeviceTrippingUnit',
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPE: 'IfcProtectiveDeviceTrippingUnitType',
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPEENUM: 'IfcProtectiveDeviceTrippingUnitTypeEnum',
  IFCPROTECTIVEDEVICETYPE: 'IfcProtectiveDeviceType',
  IFCPROTECTIVEDEVICETYPEENUM: 'IfcProtectiveDeviceTypeEnum',
  IFCPROXY: 'IfcProxy',
  IFCPUMP: 'IfcPump',
  IFCPUMPTYPE: 'IfcPumpType',
  IFCPUMPTYPEENUM: 'IfcPumpTypeEnum',
  IFCQUANTITYAREA: 'IfcQuantityArea',
  IFCQUANTITYCOUNT: 'IfcQuantityCount',
  IFCQUANTITYLENGTH: 'IfcQuantityLength',
  IFCQUANTITYNUMBER: 'IfcQuantityNumber',
  IFCQUANTITYSET: 'IfcQuantitySet',
  IFCQUANTITYTIME: 'IfcQuantityTime',
  IFCQUANTITYVOLUME: 'IfcQuantityVolume',
  IFCQUANTITYWEIGHT: 'IfcQuantityWeight',
  IFCRADIOACTIVITYMEASURE: 'IfcRadioActivityMeasure',
  IFCRADIUSDIMENSION: 'IfcRadiusDimension',
  IFCRAIL: 'IfcRail',
  IFCRAILTYPE: 'IfcRailType',
  IFCRAILTYPEENUM: 'IfcRailTypeEnum',
  IFCRAILING: 'IfcRailing',
  IFCRAILINGTYPE: 'IfcRailingType',
  IFCRAILINGTYPEENUM: 'IfcRailingTypeEnum',
  IFCRAILWAY: 'IfcRailway',
  IFCRAILWAYPART: 'IfcRailwayPart',
  IFCRAILWAYPARTTYPEENUM: 'IfcRailwayPartTypeEnum',
  IFCRAILWAYTYPEENUM: 'IfcRailwayTypeEnum',
  IFCRAMP: 'IfcRamp',
  IFCRAMPFLIGHT: 'IfcRampFlight',
  IFCRAMPFLIGHTTYPE: 'IfcRampFlightType',
  IFCRAMPFLIGHTTYPEENUM: 'IfcRampFlightTypeEnum',
  IFCRAMPTYPE: 'IfcRampType',
  IFCRAMPTYPEENUM: 'IfcRampTypeEnum',
  IFCRATIOMEASURE: 'IfcRatioMeasure',
  IFCRATIONALBSPLINECURVEWITHKNOTS: 'IfcRationalBSplineCurveWithKnots',
  IFCRATIONALBSPLINESURFACEWITHKNOTS: 'IfcRationalBSplineSurfaceWithKnots',
  IFCRATIONALBEZIERCURVE: 'IfcRationalBezierCurve',
  IFCREAL: 'IfcReal',
  IFCRECTANGLEHOLLOWPROFILEDEF: 'IfcRectangleHollowProfileDef',
  IFCRECTANGLEPROFILEDEF: 'IfcRectangleProfileDef',
  IFCRECTANGULARPYRAMID: 'IfcRectangularPyramid',
  IFCRECTANGULARTRIMMEDSURFACE: 'IfcRectangularTrimmedSurface',
  IFCRECURRENCEPATTERN: 'IfcRecurrencePattern',
  IFCRECURRENCETYPEENUM: 'IfcRecurrenceTypeEnum',
  IFCREFERENCE: 'IfcReference',
  IFCREFERENCESVALUEDOCUMENT: 'IfcReferencesValueDocument',
  IFCREFERENT: 'IfcReferent',
  IFCREFERENTTYPEENUM: 'IfcReferentTypeEnum',
  IFCREFLECTANCEMETHODENUM: 'IfcReflectanceMethodEnum',
  IFCREGULARTIMESERIES: 'IfcRegularTimeSeries',
  IFCREINFORCEDSOIL: 'IfcReinforcedSoil',
  IFCREINFORCEDSOILTYPEENUM: 'IfcReinforcedSoilTypeEnum',
  IFCREINFORCEMENTBARPROPERTIES: 'IfcReinforcementBarProperties',
  IFCREINFORCEMENTDEFINITIONPROPERTIES: 'IfcReinforcementDefinitionProperties',
  IFCREINFORCINGBAR: 'IfcReinforcingBar',
  IFCREINFORCINGBARROLEENUM: 'IfcReinforcingBarRoleEnum',
  IFCREINFORCINGBARSURFACEENUM: 'IfcReinforcingBarSurfaceEnum',
  IFCREINFORCINGBARTYPE: 'IfcReinforcingBarType',
  IFCREINFORCINGBARTYPEENUM: 'IfcReinforcingBarTypeEnum',
  IFCREINFORCINGELEMENT: 'IfcReinforcingElement',
  IFCREINFORCINGELEMENTTYPE: 'IfcReinforcingElementType',
  IFCREINFORCINGMESH: 'IfcReinforcingMesh',
  IFCREINFORCINGMESHTYPE: 'IfcReinforcingMeshType',
  IFCREINFORCINGMESHTYPEENUM: 'IfcReinforcingMeshTypeEnum',
  IFCRELADHERESTOELEMENT: 'IfcRelAdheresToElement',
  IFCRELAGGREGATES: 'IfcRelAggregates',
  IFCRELASSIGNS: 'IfcRelAssigns',
  IFCRELASSIGNSTASKS: 'IfcRelAssignsTasks',
  IFCRELASSIGNSTOACTOR: 'IfcRelAssignsToActor',
  IFCRELASSIGNSTOCONTROL: 'IfcRelAssignsToControl',
  IFCRELASSIGNSTOGROUP: 'IfcRelAssignsToGroup',
  IFCRELASSIGNSTOGROUPBYFACTOR: 'IfcRelAssignsToGroupByFactor',
  IFCRELASSIGNSTOPROCESS: 'IfcRelAssignsToProcess',
  IFCRELASSIGNSTOPRODUCT: 'IfcRelAssignsToProduct',
  IFCRELASSIGNSTOPROJECTORDER: 'IfcRelAssignsToProjectOrder',
  IFCRELASSIGNSTORESOURCE: 'IfcRelAssignsToResource',
  IFCRELASSOCIATES: 'IfcRelAssociates',
  IFCRELASSOCIATESAPPLIEDVALUE: 'IfcRelAssociatesAppliedValue',
  IFCRELASSOCIATESAPPROVAL: 'IfcRelAssociatesApproval',
  IFCRELASSOCIATESCLASSIFICATION: 'IfcRelAssociatesClassification',
  IFCRELASSOCIATESCONSTRAINT: 'IfcRelAssociatesConstraint',
  IFCRELASSOCIATESDOCUMENT: 'IfcRelAssociatesDocument',
  IFCRELASSOCIATESLIBRARY: 'IfcRelAssociatesLibrary',
  IFCRELASSOCIATESMATERIAL: 'IfcRelAssociatesMaterial',
  IFCRELASSOCIATESPROFILEDEF: 'IfcRelAssociatesProfileDef',
  IFCRELASSOCIATESPROFILEPROPERTIES: 'IfcRelAssociatesProfileProperties',
  IFCRELCONNECTS: 'IfcRelConnects',
  IFCRELCONNECTSELEMENTS: 'IfcRelConnectsElements',
  IFCRELCONNECTSPATHELEMENTS: 'IfcRelConnectsPathElements',
  IFCRELCONNECTSPORTTOELEMENT: 'IfcRelConnectsPortToElement',
  IFCRELCONNECTSPORTS: 'IfcRelConnectsPorts',
  IFCRELCONNECTSSTRUCTURALACTIVITY: 'IfcRelConnectsStructuralActivity',
  IFCRELCONNECTSSTRUCTURALELEMENT: 'IfcRelConnectsStructuralElement',
  IFCRELCONNECTSSTRUCTURALMEMBER: 'IfcRelConnectsStructuralMember',
  IFCRELCONNECTSWITHECCENTRICITY: 'IfcRelConnectsWithEccentricity',
  IFCRELCONNECTSWITHREALIZINGELEMENTS: 'IfcRelConnectsWithRealizingElements',
  IFCRELCONTAINEDINSPATIALSTRUCTURE: 'IfcRelContainedInSpatialStructure',
  IFCRELCOVERSBLDGELEMENTS: 'IfcRelCoversBldgElements',
  IFCRELCOVERSSPACES: 'IfcRelCoversSpaces',
  IFCRELDECLARES: 'IfcRelDeclares',
  IFCRELDECOMPOSES: 'IfcRelDecomposes',
  IFCRELDEFINES: 'IfcRelDefines',
  IFCRELDEFINESBYOBJECT: 'IfcRelDefinesByObject',
  IFCRELDEFINESBYPROPERTIES: 'IfcRelDefinesByProperties',
  IFCRELDEFINESBYTEMPLATE: 'IfcRelDefinesByTemplate',
  IFCRELDEFINESBYTYPE: 'IfcRelDefinesByType',
  IFCRELFILLSELEMENT: 'IfcRelFillsElement',
  IFCRELFLOWCONTROLELEMENTS: 'IfcRelFlowControlElements',
  IFCRELINTERACTIONREQUIREMENTS: 'IfcRelInteractionRequirements',
  IFCRELINTERFERESELEMENTS: 'IfcRelInterferesElements',
  IFCRELNESTS: 'IfcRelNests',
  IFCRELOCCUPIESSPACES: 'IfcRelOccupiesSpaces',
  IFCRELOVERRIDESPROPERTIES: 'IfcRelOverridesProperties',
  IFCRELPOSITIONS: 'IfcRelPositions',
  IFCRELPROJECTSELEMENT: 'IfcRelProjectsElement',
  IFCRELREFERENCEDINSPATIALSTRUCTURE: 'IfcRelReferencedInSpatialStructure',
  IFCRELSCHEDULESCOSTITEMS: 'IfcRelSchedulesCostItems',
  IFCRELSEQUENCE: 'IfcRelSequence',
  IFCRELSERVICESBUILDINGS: 'IfcRelServicesBuildings',
  IFCRELSPACEBOUNDARY: 'IfcRelSpaceBoundary',
  IFCRELVOIDSELEMENT: 'IfcRelVoidsElement',
  IFCRELATIONSHIP: 'IfcRelationship',
  IFCRELAXATION: 'IfcRelaxation',
  IFCREPARAMETRISEDCOMPOSITECURVESEGMENT: 'IfcReparametrisedCompositeCurveSegment',
  IFCREPRESENTATION: 'IfcRepresentation',
  IFCREPRESENTATIONCONTEXT: 'IfcRepresentationContext',
  IFCREPRESENTATIONITEM: 'IfcRepresentationItem',
  IFCREPRESENTATIONMAP: 'IfcRepresentationMap',
  IFCRESOURCE: 'IfcResource',
  IFCRESOURCEAPPROVALRELATIONSHIP: 'IfcResourceApprovalRelationship',
  IFCRESOURCECONSTRAINTRELATIONSHIP: 'IfcResourceConstraintRelationship',
  IFCRESOURCECONSUMPTIONENUM: 'IfcResourceConsumptionEnum',
  IFCRESOURCELEVELRELATIONSHIP: 'IfcResourceLevelRelationship',
  IFCRESOURCETIME: 'IfcResourceTime',
  IFCREVOLVEDAREASOLID: 'IfcRevolvedAreaSolid',
  IFCREVOLVEDAREASOLIDTAPERED: 'IfcRevolvedAreaSolidTapered',
  IFCRIBPLATEDIRECTIONENUM: 'IfcRibPlateDirectionEnum',
  IFCRIBPLATEPROFILEPROPERTIES: 'IfcRibPlateProfileProperties',
  IFCRIGHTCIRCULARCONE: 'IfcRightCircularCone',
  IFCRIGHTCIRCULARCYLINDER: 'IfcRightCircularCylinder',
  IFCRIGIDOPERATION: 'IfcRigidOperation',
  IFCROAD: 'IfcRoad',
  IFCROADPART: 'IfcRoadPart',
  IFCROADPARTTYPEENUM: 'IfcRoadPartTypeEnum',
  IFCROADTYPEENUM: 'IfcRoadTypeEnum',
  IFCROLEENUM: 'IfcRoleEnum',
  IFCROOF: 'IfcRoof',
  IFCROOFTYPE: 'IfcRoofType',
  IFCROOFTYPEENUM: 'IfcRoofTypeEnum',
  IFCROOT: 'IfcRoot',
  IFCROTATIONALFREQUENCYMEASURE: 'IfcRotationalFrequencyMeasure',
  IFCROTATIONALMASSMEASURE: 'IfcRotationalMassMeasure',
  IFCROTATIONALSTIFFNESSMEASURE: 'IfcRotationalStiffnessMeasure',
  IFCROUNDEDEDGEFEATURE: 'IfcRoundedEdgeFeature',
  IFCROUNDEDRECTANGLEPROFILEDEF: 'IfcRoundedRectangleProfileDef',
  IFCSIPREFIX: 'IfcSIPrefix',
  IFCSIUNIT: 'IfcSIUnit',
  IFCSIUNITNAME: 'IfcSIUnitName',
  IFCSANITARYTERMINAL: 'IfcSanitaryTerminal',
  IFCSANITARYTERMINALTYPE: 'IfcSanitaryTerminalType',
  IFCSANITARYTERMINALTYPEENUM: 'IfcSanitaryTerminalTypeEnum',
  IFCSCHEDULETIMECONTROL: 'IfcScheduleTimeControl',
  IFCSCHEDULINGTIME: 'IfcSchedulingTime',
  IFCSEAMCURVE: 'IfcSeamCurve',
  IFCSECONDINMINUTE: 'IfcSecondInMinute',
  IFCSECONDORDERPOLYNOMIALSPIRAL: 'IfcSecondOrderPolynomialSpiral',
  IFCSECTIONMODULUSMEASURE: 'IfcSectionModulusMeasure',
  IFCSECTIONPROPERTIES: 'IfcSectionProperties',
  IFCSECTIONREINFORCEMENTPROPERTIES: 'IfcSectionReinforcementProperties',
  IFCSECTIONTYPEENUM: 'IfcSectionTypeEnum',
  IFCSECTIONALAREAINTEGRALMEASURE: 'IfcSectionalAreaIntegralMeasure',
  IFCSECTIONEDSOLID: 'IfcSectionedSolid',
  IFCSECTIONEDSOLIDHORIZONTAL: 'IfcSectionedSolidHorizontal',
  IFCSECTIONEDSPINE: 'IfcSectionedSpine',
  IFCSECTIONEDSURFACE: 'IfcSectionedSurface',
  IFCSEGMENT: 'IfcSegment',
  IFCSEGMENTEDREFERENCECURVE: 'IfcSegmentedReferenceCurve',
  IFCSENSOR: 'IfcSensor',
  IFCSENSORTYPE: 'IfcSensorType',
  IFCSENSORTYPEENUM: 'IfcSensorTypeEnum',
  IFCSEQUENCEENUM: 'IfcSequenceEnum',
  IFCSERVICELIFE: 'IfcServiceLife',
  IFCSERVICELIFEFACTOR: 'IfcServiceLifeFactor',
  IFCSERVICELIFEFACTORTYPEENUM: 'IfcServiceLifeFactorTypeEnum',
  IFCSERVICELIFETYPEENUM: 'IfcServiceLifeTypeEnum',
  IFCSEVENTHORDERPOLYNOMIALSPIRAL: 'IfcSeventhOrderPolynomialSpiral',
  IFCSHADINGDEVICE: 'IfcShadingDevice',
  IFCSHADINGDEVICETYPE: 'IfcShadingDeviceType',
  IFCSHADINGDEVICETYPEENUM: 'IfcShadingDeviceTypeEnum',
  IFCSHAPEASPECT: 'IfcShapeAspect',
  IFCSHAPEMODEL: 'IfcShapeModel',
  IFCSHAPEREPRESENTATION: 'IfcShapeRepresentation',
  IFCSHEARMODULUSMEASURE: 'IfcShearModulusMeasure',
  IFCSHELLBASEDSURFACEMODEL: 'IfcShellBasedSurfaceModel',
  IFCSIGN: 'IfcSign',
  IFCSIGNTYPE: 'IfcSignType',
  IFCSIGNTYPEENUM: 'IfcSignTypeEnum',
  IFCSIGNAL: 'IfcSignal',
  IFCSIGNALTYPE: 'IfcSignalType',
  IFCSIGNALTYPEENUM: 'IfcSignalTypeEnum',
  IFCSIMPLEPROPERTY: 'IfcSimpleProperty',
  IFCSIMPLEPROPERTYTEMPLATE: 'IfcSimplePropertyTemplate',
  IFCSIMPLEPROPERTYTEMPLATETYPEENUM: 'IfcSimplePropertyTemplateTypeEnum',
  IFCSINESPIRAL: 'IfcSineSpiral',
  IFCSITE: 'IfcSite',
  IFCSLAB: 'IfcSlab',
  IFCSLABELEMENTEDCASE: 'IfcSlabElementedCase',
  IFCSLABSTANDARDCASE: 'IfcSlabStandardCase',
  IFCSLABTYPE: 'IfcSlabType',
  IFCSLABTYPEENUM: 'IfcSlabTypeEnum',
  IFCSLIPPAGECONNECTIONCONDITION: 'IfcSlippageConnectionCondition',
  IFCSOLARDEVICE: 'IfcSolarDevice',
  IFCSOLARDEVICETYPE: 'IfcSolarDeviceType',
  IFCSOLARDEVICETYPEENUM: 'IfcSolarDeviceTypeEnum',
  IFCSOLIDANGLEMEASURE: 'IfcSolidAngleMeasure',
  IFCSOLIDMODEL: 'IfcSolidModel',
  IFCSOUNDPOWERLEVELMEASURE: 'IfcSoundPowerLevelMeasure',
  IFCSOUNDPOWERMEASURE: 'IfcSoundPowerMeasure',
  IFCSOUNDPRESSURELEVELMEASURE: 'IfcSoundPressureLevelMeasure',
  IFCSOUNDPRESSUREMEASURE: 'IfcSoundPressureMeasure',
  IFCSOUNDPROPERTIES: 'IfcSoundProperties',
  IFCSOUNDSCALEENUM: 'IfcSoundScaleEnum',
  IFCSOUNDVALUE: 'IfcSoundValue',
  IFCSPACE: 'IfcSpace',
  IFCSPACEHEATER: 'IfcSpaceHeater',
  IFCSPACEHEATERTYPE: 'IfcSpaceHeaterType',
  IFCSPACEHEATERTYPEENUM: 'IfcSpaceHeaterTypeEnum',
  IFCSPACEPROGRAM: 'IfcSpaceProgram',
  IFCSPACETHERMALLOADPROPERTIES: 'IfcSpaceThermalLoadProperties',
  IFCSPACETYPE: 'IfcSpaceType',
  IFCSPACETYPEENUM: 'IfcSpaceTypeEnum',
  IFCSPATIALELEMENT: 'IfcSpatialElement',
  IFCSPATIALELEMENTTYPE: 'IfcSpatialElementType',
  IFCSPATIALSTRUCTUREELEMENT: 'IfcSpatialStructureElement',
  IFCSPATIALSTRUCTUREELEMENTTYPE: 'IfcSpatialStructureElementType',
  IFCSPATIALZONE: 'IfcSpatialZone',
  IFCSPATIALZONETYPE: 'IfcSpatialZoneType',
  IFCSPATIALZONETYPEENUM: 'IfcSpatialZoneTypeEnum',
  IFCSPECIFICHEATCAPACITYMEASURE: 'IfcSpecificHeatCapacityMeasure',
  IFCSPECULAREXPONENT: 'IfcSpecularExponent',
  IFCSPECULARROUGHNESS: 'IfcSpecularRoughness',
  IFCSPHERE: 'IfcSphere',
  IFCSPHERICALSURFACE: 'IfcSphericalSurface',
  IFCSPIRAL: 'IfcSpiral',
  IFCSTACKTERMINAL: 'IfcStackTerminal',
  IFCSTACKTERMINALTYPE: 'IfcStackTerminalType',
  IFCSTACKTERMINALTYPEENUM: 'IfcStackTerminalTypeEnum',
  IFCSTAIR: 'IfcStair',
  IFCSTAIRFLIGHT: 'IfcStairFlight',
  IFCSTAIRFLIGHTTYPE: 'IfcStairFlightType',
  IFCSTAIRFLIGHTTYPEENUM: 'IfcStairFlightTypeEnum',
  IFCSTAIRTYPE: 'IfcStairType',
  IFCSTAIRTYPEENUM: 'IfcStairTypeEnum',
  IFCSTATEENUM: 'IfcStateEnum',
  IFCSTRIPPEDOPTIONAL: 'IfcStrippedOptional',
  IFCSTRUCTURALACTION: 'IfcStructuralAction',
  IFCSTRUCTURALACTIVITY: 'IfcStructuralActivity',
  IFCSTRUCTURALANALYSISMODEL: 'IfcStructuralAnalysisModel',
  IFCSTRUCTURALCONNECTION: 'IfcStructuralConnection',
  IFCSTRUCTURALCONNECTIONCONDITION: 'IfcStructuralConnectionCondition',
  IFCSTRUCTURALCURVEACTION: 'IfcStructuralCurveAction',
  IFCSTRUCTURALCURVEACTIVITYTYPEENUM: 'IfcStructuralCurveActivityTypeEnum',
  IFCSTRUCTURALCURVECONNECTION: 'IfcStructuralCurveConnection',
  IFCSTRUCTURALCURVEMEMBER: 'IfcStructuralCurveMember',
  IFCSTRUCTURALCURVEMEMBERTYPEENUM: 'IfcStructuralCurveMemberTypeEnum',
  IFCSTRUCTURALCURVEMEMBERVARYING: 'IfcStructuralCurveMemberVarying',
  IFCSTRUCTURALCURVEREACTION: 'IfcStructuralCurveReaction',
  IFCSTRUCTURALCURVETYPEENUM: 'IfcStructuralCurveTypeEnum',
  IFCSTRUCTURALITEM: 'IfcStructuralItem',
  IFCSTRUCTURALLINEARACTION: 'IfcStructuralLinearAction',
  IFCSTRUCTURALLINEARACTIONVARYING: 'IfcStructuralLinearActionVarying',
  IFCSTRUCTURALLOAD: 'IfcStructuralLoad',
  IFCSTRUCTURALLOADCASE: 'IfcStructuralLoadCase',
  IFCSTRUCTURALLOADCONFIGURATION: 'IfcStructuralLoadConfiguration',
  IFCSTRUCTURALLOADGROUP: 'IfcStructuralLoadGroup',
  IFCSTRUCTURALLOADLINEARFORCE: 'IfcStructuralLoadLinearForce',
  IFCSTRUCTURALLOADORRESULT: 'IfcStructuralLoadOrResult',
  IFCSTRUCTURALLOADPLANARFORCE: 'IfcStructuralLoadPlanarForce',
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT: 'IfcStructuralLoadSingleDisplacement',
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION: 'IfcStructuralLoadSingleDisplacementDistortion',
  IFCSTRUCTURALLOADSINGLEFORCE: 'IfcStructuralLoadSingleForce',
  IFCSTRUCTURALLOADSINGLEFORCEWARPING: 'IfcStructuralLoadSingleForceWarping',
  IFCSTRUCTURALLOADSTATIC: 'IfcStructuralLoadStatic',
  IFCSTRUCTURALLOADTEMPERATURE: 'IfcStructuralLoadTemperature',
  IFCSTRUCTURALMEMBER: 'IfcStructuralMember',
  IFCSTRUCTURALPLANARACTION: 'IfcStructuralPlanarAction',
  IFCSTRUCTURALPLANARACTIONVARYING: 'IfcStructuralPlanarActionVarying',
  IFCSTRUCTURALPOINTACTION: 'IfcStructuralPointAction',
  IFCSTRUCTURALPOINTCONNECTION: 'IfcStructuralPointConnection',
  IFCSTRUCTURALPOINTREACTION: 'IfcStructuralPointReaction',
  IFCSTRUCTURALPROFILEPROPERTIES: 'IfcStructuralProfileProperties',
  IFCSTRUCTURALREACTION: 'IfcStructuralReaction',
  IFCSTRUCTURALRESULTGROUP: 'IfcStructuralResultGroup',
  IFCSTRUCTURALSTEELPROFILEPROPERTIES: 'IfcStructuralSteelProfileProperties',
  IFCSTRUCTURALSURFACEACTION: 'IfcStructuralSurfaceAction',
  IFCSTRUCTURALSURFACEACTIVITYTYPEENUM: 'IfcStructuralSurfaceActivityTypeEnum',
  IFCSTRUCTURALSURFACECONNECTION: 'IfcStructuralSurfaceConnection',
  IFCSTRUCTURALSURFACEMEMBER: 'IfcStructuralSurfaceMember',
  IFCSTRUCTURALSURFACEMEMBERTYPEENUM: 'IfcStructuralSurfaceMemberTypeEnum',
  IFCSTRUCTURALSURFACEMEMBERVARYING: 'IfcStructuralSurfaceMemberVarying',
  IFCSTRUCTURALSURFACEREACTION: 'IfcStructuralSurfaceReaction',
  IFCSTRUCTURALSURFACETYPEENUM: 'IfcStructuralSurfaceTypeEnum',
  IFCSTRUCTUREDDIMENSIONCALLOUT: 'IfcStructuredDimensionCallout',
  IFCSTYLEMODEL: 'IfcStyleModel',
  IFCSTYLEDITEM: 'IfcStyledItem',
  IFCSTYLEDREPRESENTATION: 'IfcStyledRepresentation',
  IFCSUBCONTRACTRESOURCE: 'IfcSubContractResource',
  IFCSUBCONTRACTRESOURCETYPE: 'IfcSubContractResourceType',
  IFCSUBCONTRACTRESOURCETYPEENUM: 'IfcSubContractResourceTypeEnum',
  IFCSUBEDGE: 'IfcSubedge',
  IFCSURFACE: 'IfcSurface',
  IFCSURFACECURVE: 'IfcSurfaceCurve',
  IFCSURFACECURVESWEPTAREASOLID: 'IfcSurfaceCurveSweptAreaSolid',
  IFCSURFACEFEATURE: 'IfcSurfaceFeature',
  IFCSURFACEFEATURETYPEENUM: 'IfcSurfaceFeatureTypeEnum',
  IFCSURFACEOFLINEAREXTRUSION: 'IfcSurfaceOfLinearExtrusion',
  IFCSURFACEOFREVOLUTION: 'IfcSurfaceOfRevolution',
  IFCSURFACEREINFORCEMENTAREA: 'IfcSurfaceReinforcementArea',
  IFCSURFACESIDE: 'IfcSurfaceSide',
  IFCSURFACESTYLE: 'IfcSurfaceStyle',
  IFCSURFACESTYLELIGHTING: 'IfcSurfaceStyleLighting',
  IFCSURFACESTYLEREFRACTION: 'IfcSurfaceStyleRefraction',
  IFCSURFACESTYLERENDERING: 'IfcSurfaceStyleRendering',
  IFCSURFACESTYLESHADING: 'IfcSurfaceStyleShading',
  IFCSURFACESTYLEWITHTEXTURES: 'IfcSurfaceStyleWithTextures',
  IFCSURFACETEXTURE: 'IfcSurfaceTexture',
  IFCSURFACETEXTUREENUM: 'IfcSurfaceTextureEnum',
  IFCSWEPTAREASOLID: 'IfcSweptAreaSolid',
  IFCSWEPTDISKSOLID: 'IfcSweptDiskSolid',
  IFCSWEPTDISKSOLIDPOLYGONAL: 'IfcSweptDiskSolidPolygonal',
  IFCSWEPTSURFACE: 'IfcSweptSurface',
  IFCSWITCHINGDEVICE: 'IfcSwitchingDevice',
  IFCSWITCHINGDEVICETYPE: 'IfcSwitchingDeviceType',
  IFCSWITCHINGDEVICETYPEENUM: 'IfcSwitchingDeviceTypeEnum',
  IFCSYMBOLSTYLE: 'IfcSymbolStyle',
  IFCSYSTEM: 'IfcSystem',
  IFCSYSTEMFURNITUREELEMENT: 'IfcSystemFurnitureElement',
  IFCSYSTEMFURNITUREELEMENTTYPE: 'IfcSystemFurnitureElementType',
  IFCSYSTEMFURNITUREELEMENTTYPEENUM: 'IfcSystemFurnitureElementTypeEnum',
  IFCTSHAPEPROFILEDEF: 'IfcTShapeProfileDef',
  IFCTABLE: 'IfcTable',
  IFCTABLECOLUMN: 'IfcTableColumn',
  IFCTABLEROW: 'IfcTableRow',
  IFCTANK: 'IfcTank',
  IFCTANKTYPE: 'IfcTankType',
  IFCTANKTYPEENUM: 'IfcTankTypeEnum',
  IFCTASK: 'IfcTask',
  IFCTASKDURATIONENUM: 'IfcTaskDurationEnum',
  IFCTASKTIME: 'IfcTaskTime',
  IFCTASKTIMERECURRING: 'IfcTaskTimeRecurring',
  IFCTASKTYPE: 'IfcTaskType',
  IFCTASKTYPEENUM: 'IfcTaskTypeEnum',
  IFCTELECOMADDRESS: 'IfcTelecomAddress',
  IFCTEMPERATUREGRADIENTMEASURE: 'IfcTemperatureGradientMeasure',
  IFCTEMPERATURERATEOFCHANGEMEASURE: 'IfcTemperatureRateOfChangeMeasure',
  IFCTENDON: 'IfcTendon',
  IFCTENDONANCHOR: 'IfcTendonAnchor',
  IFCTENDONANCHORTYPE: 'IfcTendonAnchorType',
  IFCTENDONANCHORTYPEENUM: 'IfcTendonAnchorTypeEnum',
  IFCTENDONCONDUIT: 'IfcTendonConduit',
  IFCTENDONCONDUITTYPE: 'IfcTendonConduitType',
  IFCTENDONCONDUITTYPEENUM: 'IfcTendonConduitTypeEnum',
  IFCTENDONTYPE: 'IfcTendonType',
  IFCTENDONTYPEENUM: 'IfcTendonTypeEnum',
  IFCTERMINATORSYMBOL: 'IfcTerminatorSymbol',
  IFCTESSELLATEDFACESET: 'IfcTessellatedFaceSet',
  IFCTESSELLATEDITEM: 'IfcTessellatedItem',
  IFCTEXT: 'IfcText',
  IFCTEXTALIGNMENT: 'IfcTextAlignment',
  IFCTEXTDECORATION: 'IfcTextDecoration',
  IFCTEXTFONTNAME: 'IfcTextFontName',
  IFCTEXTLITERAL: 'IfcTextLiteral',
  IFCTEXTLITERALWITHEXTENT: 'IfcTextLiteralWithExtent',
  IFCTEXTPATH: 'IfcTextPath',
  IFCTEXTSTYLE: 'IfcTextStyle',
  IFCTEXTSTYLEFONTMODEL: 'IfcTextStyleFontModel',
  IFCTEXTSTYLEFORDEFINEDFONT: 'IfcTextStyleForDefinedFont',
  IFCTEXTSTYLETEXTMODEL: 'IfcTextStyleTextModel',
  IFCTEXTSTYLEWITHBOXCHARACTERISTICS: 'IfcTextStyleWithBoxCharacteristics',
  IFCTEXTTRANSFORMATION: 'IfcTextTransformation',
  IFCTEXTURECOORDINATE: 'IfcTextureCoordinate',
  IFCTEXTURECOORDINATEGENERATOR: 'IfcTextureCoordinateGenerator',
  IFCTEXTURECOORDINATEINDICES: 'IfcTextureCoordinateIndices',
  IFCTEXTURECOORDINATEINDICESWITHVOIDS: 'IfcTextureCoordinateIndicesWithVoids',
  IFCTEXTUREMAP: 'IfcTextureMap',
  IFCTEXTUREVERTEX: 'IfcTextureVertex',
  IFCTEXTUREVERTEXLIST: 'IfcTextureVertexList',
  IFCTHERMALADMITTANCEMEASURE: 'IfcThermalAdmittanceMeasure',
  IFCTHERMALCONDUCTIVITYMEASURE: 'IfcThermalConductivityMeasure',
  IFCTHERMALEXPANSIONCOEFFICIENTMEASURE: 'IfcThermalExpansionCoefficientMeasure',
  IFCTHERMALLOADSOURCEENUM: 'IfcThermalLoadSourceEnum',
  IFCTHERMALLOADTYPEENUM: 'IfcThermalLoadTypeEnum',
  IFCTHERMALMATERIALPROPERTIES: 'IfcThermalMaterialProperties',
  IFCTHERMALRESISTANCEMEASURE: 'IfcThermalResistanceMeasure',
  IFCTHERMALTRANSMITTANCEMEASURE: 'IfcThermalTransmittanceMeasure',
  IFCTHERMODYNAMICTEMPERATUREMEASURE: 'IfcThermodynamicTemperatureMeasure',
  IFCTHIRDORDERPOLYNOMIALSPIRAL: 'IfcThirdOrderPolynomialSpiral',
  IFCTIME: 'IfcTime',
  IFCTIMEMEASURE: 'IfcTimeMeasure',
  IFCTIMEPERIOD: 'IfcTimePeriod',
  IFCTIMESERIES: 'IfcTimeSeries',
  IFCTIMESERIESDATATYPEENUM: 'IfcTimeSeriesDataTypeEnum',
  IFCTIMESERIESREFERENCERELATIONSHIP: 'IfcTimeSeriesReferenceRelationship',
  IFCTIMESERIESSCHEDULE: 'IfcTimeSeriesSchedule',
  IFCTIMESERIESSCHEDULETYPEENUM: 'IfcTimeSeriesScheduleTypeEnum',
  IFCTIMESERIESVALUE: 'IfcTimeSeriesValue',
  IFCTIMESTAMP: 'IfcTimeStamp',
  IFCTOPOLOGICALREPRESENTATIONITEM: 'IfcTopologicalRepresentationItem',
  IFCTOPOLOGYREPRESENTATION: 'IfcTopologyRepresentation',
  IFCTOROIDALSURFACE: 'IfcToroidalSurface',
  IFCTORQUEMEASURE: 'IfcTorqueMeasure',
  IFCTRACKELEMENT: 'IfcTrackElement',
  IFCTRACKELEMENTTYPE: 'IfcTrackElementType',
  IFCTRACKELEMENTTYPEENUM: 'IfcTrackElementTypeEnum',
  IFCTRANSFORMER: 'IfcTransformer',
  IFCTRANSFORMERTYPE: 'IfcTransformerType',
  IFCTRANSFORMERTYPEENUM: 'IfcTransformerTypeEnum',
  IFCTRANSITIONCODE: 'IfcTransitionCode',
  IFCTRANSPORTELEMENT: 'IfcTransportElement',
  IFCTRANSPORTELEMENTTYPE: 'IfcTransportElementType',
  IFCTRANSPORTELEMENTTYPEENUM: 'IfcTransportElementTypeEnum',
  IFCTRANSPORTATIONDEVICE: 'IfcTransportationDevice',
  IFCTRANSPORTATIONDEVICETYPE: 'IfcTransportationDeviceType',
  IFCTRAPEZIUMPROFILEDEF: 'IfcTrapeziumProfileDef',
  IFCTRIANGULATEDFACESET: 'IfcTriangulatedFaceSet',
  IFCTRIANGULATEDIRREGULARNETWORK: 'IfcTriangulatedIrregularNetwork',
  IFCTRIMMEDCURVE: 'IfcTrimmedCurve',
  IFCTRIMMINGPREFERENCE: 'IfcTrimmingPreference',
  IFCTUBEBUNDLE: 'IfcTubeBundle',
  IFCTUBEBUNDLETYPE: 'IfcTubeBundleType',
  IFCTUBEBUNDLETYPEENUM: 'IfcTubeBundleTypeEnum',
  IFCTWODIRECTIONREPEATFACTOR: 'IfcTwoDirectionRepeatFactor',
  IFCTYPEOBJECT: 'IfcTypeObject',
  IFCTYPEPROCESS: 'IfcTypeProcess',
  IFCTYPEPRODUCT: 'IfcTypeProduct',
  IFCTYPERESOURCE: 'IfcTypeResource',
  IFCURIREFERENCE: 'IfcURIReference',
  IFCUSHAPEPROFILEDEF: 'IfcUShapeProfileDef',
  IFCUNITASSIGNMENT: 'IfcUnitAssignment',
  IFCUNITENUM: 'IfcUnitEnum',
  IFCUNITARYCONTROLELEMENT: 'IfcUnitaryControlElement',
  IFCUNITARYCONTROLELEMENTTYPE: 'IfcUnitaryControlElementType',
  IFCUNITARYCONTROLELEMENTTYPEENUM: 'IfcUnitaryControlElementTypeEnum',
  IFCUNITARYEQUIPMENT: 'IfcUnitaryEquipment',
  IFCUNITARYEQUIPMENTTYPE: 'IfcUnitaryEquipmentType',
  IFCUNITARYEQUIPMENTTYPEENUM: 'IfcUnitaryEquipmentTypeEnum',
  IFCVALVE: 'IfcValve',
  IFCVALVETYPE: 'IfcValveType',
  IFCVALVETYPEENUM: 'IfcValveTypeEnum',
  IFCVAPORPERMEABILITYMEASURE: 'IfcVaporPermeabilityMeasure',
  IFCVECTOR: 'IfcVector',
  IFCVEHICLE: 'IfcVehicle',
  IFCVEHICLETYPE: 'IfcVehicleType',
  IFCVEHICLETYPEENUM: 'IfcVehicleTypeEnum',
  IFCVERTEX: 'IfcVertex',
  IFCVERTEXBASEDTEXTUREMAP: 'IfcVertexBasedTextureMap',
  IFCVERTEXLOOP: 'IfcVertexLoop',
  IFCVERTEXPOINT: 'IfcVertexPoint',
  IFCVIBRATIONDAMPER: 'IfcVibrationDamper',
  IFCVIBRATIONDAMPERTYPE: 'IfcVibrationDamperType',
  IFCVIBRATIONDAMPERTYPEENUM: 'IfcVibrationDamperTypeEnum',
  IFCVIBRATIONISOLATOR: 'IfcVibrationIsolator',
  IFCVIBRATIONISOLATORTYPE: 'IfcVibrationIsolatorType',
  IFCVIBRATIONISOLATORTYPEENUM: 'IfcVibrationIsolatorTypeEnum',
  IFCVIRTUALELEMENT: 'IfcVirtualElement',
  IFCVIRTUALELEMENTTYPEENUM: 'IfcVirtualElementTypeEnum',
  IFCVIRTUALGRIDINTERSECTION: 'IfcVirtualGridIntersection',
  IFCVOIDINGFEATURE: 'IfcVoidingFeature',
  IFCVOIDINGFEATURETYPEENUM: 'IfcVoidingFeatureTypeEnum',
  IFCVOLUMEMEASURE: 'IfcVolumeMeasure',
  IFCVOLUMETRICFLOWRATEMEASURE: 'IfcVolumetricFlowRateMeasure',
  IFCWALL: 'IfcWall',
  IFCWALLELEMENTEDCASE: 'IfcWallElementedCase',
  IFCWALLSTANDARDCASE: 'IfcWallStandardCase',
  IFCWALLTYPE: 'IfcWallType',
  IFCWALLTYPEENUM: 'IfcWallTypeEnum',
  IFCWARPINGCONSTANTMEASURE: 'IfcWarpingConstantMeasure',
  IFCWARPINGMOMENTMEASURE: 'IfcWarpingMomentMeasure',
  IFCWASTETERMINAL: 'IfcWasteTerminal',
  IFCWASTETERMINALTYPE: 'IfcWasteTerminalType',
  IFCWASTETERMINALTYPEENUM: 'IfcWasteTerminalTypeEnum',
  IFCWATERPROPERTIES: 'IfcWaterProperties',
  IFCWELLKNOWNTEXT: 'IfcWellKnownText',
  IFCWELLKNOWNTEXTLITERAL: 'IfcWellKnownTextLiteral',
  IFCWINDOW: 'IfcWindow',
  IFCWINDOWLININGPROPERTIES: 'IfcWindowLiningProperties',
  IFCWINDOWPANELOPERATIONENUM: 'IfcWindowPanelOperationEnum',
  IFCWINDOWPANELPOSITIONENUM: 'IfcWindowPanelPositionEnum',
  IFCWINDOWPANELPROPERTIES: 'IfcWindowPanelProperties',
  IFCWINDOWSTANDARDCASE: 'IfcWindowStandardCase',
  IFCWINDOWSTYLE: 'IfcWindowStyle',
  IFCWINDOWSTYLECONSTRUCTIONENUM: 'IfcWindowStyleConstructionEnum',
  IFCWINDOWSTYLEOPERATIONENUM: 'IfcWindowStyleOperationEnum',
  IFCWINDOWTYPE: 'IfcWindowType',
  IFCWINDOWTYPEENUM: 'IfcWindowTypeEnum',
  IFCWINDOWTYPEPARTITIONINGENUM: 'IfcWindowTypePartitioningEnum',
  IFCWORKCALENDAR: 'IfcWorkCalendar',
  IFCWORKCALENDARTYPEENUM: 'IfcWorkCalendarTypeEnum',
  IFCWORKCONTROL: 'IfcWorkControl',
  IFCWORKCONTROLTYPEENUM: 'IfcWorkControlTypeEnum',
  IFCWORKPLAN: 'IfcWorkPlan',
  IFCWORKPLANTYPEENUM: 'IfcWorkPlanTypeEnum',
  IFCWORKSCHEDULE: 'IfcWorkSchedule',
  IFCWORKSCHEDULETYPEENUM: 'IfcWorkScheduleTypeEnum',
  IFCWORKTIME: 'IfcWorkTime',
  IFCYEARNUMBER: 'IfcYearNumber',
  IFCZSHAPEPROFILEDEF: 'IfcZShapeProfileDef',
  IFCZONE: 'IfcZone',
}

export function canonicalIfcName(rawName: string): string {
  if (!rawName) return rawName
  const known = IFC_CANONICAL_NAMES[rawName]
  if (known) return known
  // Fallback for entries not present in the bundled schema (rare:
  // future IFC versions or vendor extensions). Title-cases letters
  // following "IFC" as a single word, gives e.g. "Ifcwallplus".
  if (rawName.startsWith('IFC')) {
    return 'Ifc' + rawName.slice(3).charAt(0).toUpperCase() + rawName.slice(4).toLowerCase()
  }
  return rawName
}
